<!--
套组详情
20200331
-->
<template>
  <div>

    <!-- 页面头部 开始 -->
    <van-sticky @scroll="funPageScroll">
      <!-- 头部标题栏 开始 -->
      <div class="goodsview_header_box common_header" :class="{header_transparent: headerTransparent}">
        <div class="header_box">
          <div class="header_leftarea">
            <a class="btn" @click="this.backToPrevpage"><i class="material-icons"></i></a>
          </div>
          <div class="header_title">{{setDetail.title}}</div>
          <div class="header_rightarea">
            <a class="btn" @click="$refs.PageQr.hideSubplatePageQr(false)"><i class="material-icons">&#xe80d;</i></a>
          </div>
        </div>
      </div>
      <!-- 头部标题栏 结束 -->
      <div style="height:0">

        <div class="tab_nav" :class="{'hide': headerTransparent}">
          <a class="item" v-waves
            :class="{'active': tabScrollPostion==0}"
            @click="changeTabnavGoodsDetail('#setindex_describe')"
          ><span>描述</span></a>
          <a class="item" v-waves
            :class="{'active': tabScrollPostion==1}"
             v-if="setArticle && setArticle.length"
            @click="changeTabnavGoodsDetail('#setindex_article')"
          ><span>评测</span></a>
          <a class="item" v-waves
            :class="{'active': tabScrollPostion==2}"
            @click="changeTabnavGoodsDetail('#setindex_relset')"
          ><span >相关套组</span></a>
        </div>

      </div>
    </van-sticky>
    <!-- 页面头部 结束 -->

    <!-- 置顶区 开始 -->
    <div id="setindex_maintop" class="main_top">
      <div class="main_top_box">
      
        <div id="setindex_maintop_box">
        
          <div>

            <div class="setindex_bigcover_wrap">
              <template v-if="setDetailGetOver == 1">

                <div class="setindex_bigcover" 
                  v-lazy:background-image="{
                    src: setDetail.cover_arr[0],
                    loading: '/static/img/img_load.gif',
                    error: '/static/img/img_blank.png'
                  }"
                  @click="coverPreview"
                  v-if="setDetail.cover_arr.length == 1"
                ></div>

                <div class="setindex_bigcover_swipe" v-else-if="setDetail.cover_arr.length > 1">
                  <van-swipe ref="bigcover" :autoplay="coverAutoplay" :stop-propagation="false" @change="setDetailCoverChange">
                    <van-swipe-item v-for="(image, index) in setDetail.cover_arr" :key="index"
                      :stop-propagation="false"
                      @touchstart="onTouchStart" 
                      @touchmove="onTouchMove" 
                      @touchend="coverPreview"
                    >
                      <div class="image" 
                        v-lazy:background-image="{
                          src: image,
                          loading: '/static/img/img_load.gif',
                          error: '/static/img/img_blank.png'
                        }"
                      ></div>
                    </van-swipe-item>
                    <template #indicator>
                      <div class="custom-indicator">{{ setDetailCoverIndex + 1 }} / {{setDetail.cover_arr.length}}</div>
                    </template>
                  </van-swipe>
                  <a class="btn btn_album" @click="showSubplateAlbum=true"><i class="material-icons">&#xe413;</i></a>
                </div>

                <div class="setindex_bigcover" 
                  v-lazy:background-image="{
                    src: '/static/img/cover_blank.png',
                    loading: '/static/img/img_load.gif',
                    error: '/static/img/img_blank.png'
                  }"
                  v-else
                ></div>

              </template>
              <template v-else>
              <div class="setindex_bigcover" 
                style="background-image: url(/static/img/img_load.gif)"
              ></div>
              </template>
            </div>
      
            <div class="brandandnumber"><div class="logo"
              v-lazy:background-image="{
                src: setBrandDetail.logo ? setBrandDetail.logo : '/static/img/brand_blank.png',
                error: '/static/img/brand_blank.png'
              }"
            ></div><div class="brand" :class="{'skeleton_brand': setDetailGetOver != 1}" :title="setBrandDetail.title">{{splitBrandText(setBrandDetail.title)}}</div><div class="number" v-if="setDetail.setnumber!='【无】' && setDetail.setnumber!='【未知】' && setDetail.setnumber!='unknown'">{{setDetail.setnumber}}</div></div>
            <!-- <div class="title" :class="{'skeleton_title': setDetailGetOver != 1}">{{setDetail.title}}</div> -->
            <div class="title" :class="{'skeleton_title': setDetailGetOver != 1}">{{titleScale(0)}}<span class="model_scale" title="模型比例" v-if="titleScale(1)">{{titleScale(1)}}</span></div>
            <div class="subtitle" :class="{'skeleton_subtitle': setDetailGetOver != 1}">{{setDetail.subtitle}}</div>
            
            <div class="setindex_param">
              <div class="item_param">
                <div class="num">{{setDetail.released_year ? setDetail.released_year : '--'}}</div>
                <div>年份</div>
                <div class="sign sign_newrelease" v-if="setDetail.sign_newrelease">
                  <span>新品</span>
                </div>
                <div class="sign sign_outofprint" v-else-if="setDetail.sign_outofprint">
                  <span>{{setDetail.sign_outofprintjust ? "绝版不久" : "已绝版"}}</span>
                </div>
                <div class="sign sign_outofprintsoon" v-else-if="setDetail.sign_outofprintsoon">
                  <span>即将绝版</span>
                </div>
                <div class="sign sign_newadd" v-else-if="setDetail.sign_newadd">
                  <span>新收录</span>
                </div>
              </div>
              <div class="item_param">
                <div class="num">{{setDetail.pcs ? setDetail.pcs : '--'}}</div>
                <div>零件数</div>
                <div class="bricktype"
                  :class="'color_'+setDetail.bricktype"
                  @click="$refs.BricktypeInfo.hideSubplateBricktypeInfo(false)"
                  v-if="setDetail.bricktype > 1"
                >
                  <span v-if="setDetail.bricktype==2">大颗粒</span>
                  <span v-else-if="setDetail.bricktype==3">迷你颗粒</span>
                  <span v-else-if="setDetail.bricktype==4">微钻颗粒</span>
                  <span v-else-if="setDetail.bricktype==5">巨型</span>
                  <span v-else-if="setDetail.bricktype>=6">特殊</span>
                  <i class="material-icons">&#xe88f;</i>
                </div>
              </div>
              <div class="item_param">
                <div class="num"
                  v-if="setDetail.age_lower > 0 && setDetail.age_upper > 0"
                >
                  {{setDetail.age_lower}}-{{setDetail.age_upper}}
                </div>
                <div class="num"
                  v-else-if="setDetail.age_lower > 0 && !(setDetail.age_upper > 0)"
                >
                  {{setDetail.age_lower}}+
                </div>
                <div class="num" v-else>--</div>
                <div>年龄</div>
              </div>
            </div>

            <!-- <div class="bricktype_wrap" v-if="setDetail.bricktype > 1">
              <div class="bricktype"
                :class="'color_'+setDetail.bricktype"
                @click="$refs.BricktypeInfo.hideSubplateBricktypeInfo(false)"
              >
                <span v-if="setDetail.bricktype==2">大颗粒</span>
                <span v-if="setDetail.bricktype==3">迷你颗粒</span>
                <span v-if="setDetail.bricktype==4">微钻颗粒</span>
                <span v-if="setDetail.bricktype==5">巨型</span>
                <span v-if="setDetail.bricktype>=6">特殊</span>
                <i class="material-icons">&#xe88f;</i>
              </div>
            </div> -->
            
            <div class="table_param_wrap" v-if="hasParam">
              <div class="table_param" v-if="showParam">
                <dl v-if="setDetail.released">
                  <dt>发售/发布</dt>
                  <dd>{{setDetail.released}}</dd>
                </dl>
                <dl v-if="setDetail.outofprint">
                  <dt>绝版日期</dt>
                  <dd>{{setDetail.outofprint}}</dd>
                </dl>
                <dl v-if="setDetail.weight">
                  <dt>重量</dt>
                  <dd>{{setDetail.weight}} kg</dd>
                </dl>
                <dl v-if="setDetail.minifigs">
                  <dt>人仔数</dt>
                  <dd>{{setDetail.minifigs}}</dd>
                </dl>
                <dl v-if="setDetail.package_size">
                  <dt>包装尺寸</dt>
                  <dd>{{setDetail.package_size}} cm</dd>
                </dl>
                <dl v-if="setDetail.package_type">
                  <dt>包装形式</dt>
                  <dd>{{setDetail.package_type}}</dd>
                </dl>
                <dl v-if="setDetail.size">
                  <dt>成品尺寸</dt>
                  <dd>{{setDetail.size}} cm</dd>
                </dl>
                <dl v-if="setDetail.scale">
                  <dt>模型比例</dt>
                  <dd>1 : {{setDetail.scale}}</dd>
                </dl>
                <dl class="tr_param_ean" v-if="setDetail.ean">
                  <dt>EAN条码</dt>
                  <dd>{{setDetail.ean}}
                    <barcode v-bind:value="setDetail.ean" 
                      width="1" height="30" format="EAN13"
                      :displayValue="false"
                      background="transparent"
                      :flat="true"
                      margin="0"
                    ></barcode>
                  </dd>
                </dl>
                <dl v-if="setDetail.remarks">
                  <dt>备注</dt>
                  <dd>{{setDetail.remarks}}</dd>
                </dl>
              </div>

              <div class="btn btn_more" @click="showParam = !showParam">{{showParam ? '折叠参数表': '查看详细参数'}}</div>
            </div>
            
          </div>
          
          <div class="form_item form_item_btn" :class="{hashide: !headerTransparent && setShopping.length}">
            <div class="form_btn_part price" v-if="setPriceLower > 0">¥{{setPriceLower}}<small>起</small><div class="ppp" title="零件均价" v-if="setDetail.pcs > 0">PPP：¥{{(setPriceLower / setDetail.pcs).toFixed(4)}}</div></div>
            <div class="form_btn_part price" v-else-if="setDetail.price > 0">¥{{setDetail.price}}<div class="ppp" title="零件均价" v-if="setDetail.pcs > 0">PPP：¥{{(setDetail.price / setDetail.pcs).toFixed(4)}}</div></div>
            <div class="form_btn_part price" v-else-if="setDetail.price_dollar > 0">${{setDetail.price_dollar}}</div>
            <div class="form_btn_part price disabled" v-else>价格信息暂缺</div>
            <div class="form_btn_part">
              <button type="submit" class="form_btn btn btn_color_2 btn_round btn_shadow ink" v-waves @click="changeTabnavGoodsDetail('#setindex_shopping')" v-if="setShopping.length">购买</button>
              <button type="submit" class="form_btn btn btn_color_2 btn_round btn_shadow ink disabled" @click="$toast('暂无购买入口');" v-else>暂无购买入口</button>
            </div>
          </div>

        </div>
        
      </div>
    </div>
    <!-- 置顶区 结束 -->



    <!-- 主体 开始 -->
    <div id="setindex_main" class="main">


      <div id="setindex_describe" class="maincard_hasborder">
      
      
        
        <div class="main_title">
          <div class="title_wrap">
            <div class="title"><span>描述</span></div>
            <!--<a class="btn_more btn" href="./ridetrailtheme_list.html">更多主题</a>-->
          </div>
          <!--<div class="text">开车太快，走路太慢，骑车刚刚好。</div>-->
        </div>
        
        <div class="theme_text">
          <router-link v-for="(item, index) in setTheme" :key="index"
            :to="{name: 'SearchSet', query: {theme: item.id}}"
          >
            <span>{{item.title}} {{item.subtitle}}</span>
          </router-link>
        </div>

        <div class="original_badge original_badge_legoideas" v-if="setDetail.sign_isideas">
          <div class="logo" style="background-image: url(/static/img/ideas.png?);"></div>
          <span>LEGO Ideas 作品</span>
        </div>

        <router-link class="original_badge original_badge_rebrickable" 
          :to="{
                name: 'SetIndex',
                params: {
                  brand: 'rebrickable',
                  setnumber: setDetail.sign_rebrickable,
                }
              }"
          v-if="setDetail.sign_rebrickable"
        >
          <div class="logo" v-lazy:background-image="$store.state.api.img + 'upload/brand/brand_26.png!brand_s'"></div>
          <span>Rebrickable {{setDetail.sign_rebrickable}}</span>
        </router-link>

        <!-- <div class="list_pic">

          <div class="item_pic"
            v-for="(image, index) in setDetail.cover_arr" :key="index"
          >
            <img :src="image">
          </div>

        </div> -->


        <!-- <div id="map_container" data-no-touch-simulate v-if="setDetail.position"></div> -->
        <div id="map_staticimage" v-if="setDetail.position">
          <img :src="'https://api.map.baidu.com/staticimage?center='+ setDetail.position +'&width=600&height=400&zoom=4'">
          <div class="landmark_title" v-if="setDetail.position_country || setDetail.position_city">{{setDetail.position_country}} {{setDetail.position_city}}</div>
          <div class="landmark_pin"></div>
        </div>

        <div class="richtext_wrap" ref="set_text_wrap" :class="{folded: setRichtextFolded}" v-if="setDetailGetOver==1">

          <div class="richtext">
            <div class="set_text"
              ref="set_text"
              v-html="setDetail.text"
            >
            </div>
            
          </div>
          <div class="card_more" v-if="setRichtextTooLong" @click="foldAndScrollRichtext"><span v-if="setRichtextFolded">展开全部内容</span><span v-else>折叠内容</span></div>
        
        </div>

        
        <div class="nothing nothing_load" v-if="setDetailGetOver==0">
          <!-- <i class="material-icons big">&#xe88b;</i> -->
          <!-- <div>载入中</div> -->
          <div><small>稍等……</small></div>
        </div>

        <div class="nothing nothing_load" v-if="setDetailGetOver==2">
          <!-- <i class="material-icons big">&#xe88b;</i> -->
          <!-- <div>载入中</div> -->
          <div><small>套组资料载入失败</small></div>
          <a class="btn" @click="pageReload()">点击重新加载</a>
        </div>
        
        
      </div>
      

      <div id="setindex_minifigs" class="maincard_hasborder" v-if="setMinifigs && setMinifigs.length">
      
        <div class="main_title">
          <div class="title_wrap">
            <div class="title">人仔{{countMinifigs()}}</div>
          </div>
        </div>
        
        
        <div class="list_setindex_minifigs_wrap">
          <div class="list_setindex_minifigs">
          
            <div class="item_setindex_minifigs"
              v-for="(item, index) in setMinifigs" :key="index"
              :title="item.name"
            >
              <div class="img"><img v-lazy="{
                src: item.cover,
                error: '/static/img/minifig_blank.png',
                loading: '/static/img/minifig_blank.png'
              }"></div>
              <div class="sign" v-if="item.unique">独占</div>
              <div class="code">{{item.code}}</div>
              <div class="name" v-if="item.name">{{item.name}}</div>
            </div>

            <div class="doufu"></div>
            
          </div>
        </div>
        
        
      
      </div>


      <div id="setindex_designer" class="maincard_hasborder" v-if="setDesigner && setDesigner.length">
      
        <div class="main_title">
          <div class="title_wrap">
            <div class="title">相关设计师{{setDesigner.length ? "（"+ setDesigner.length +"）" : ""}}</div>
            <!--<a class="btn_more btn" href="./ridetrailtheme_list.html">更多主题</a>-->
          </div>
          <!--<div class="text">开车太快，走路太慢，骑车刚刚好。</div>-->
        </div>
        
        
        <div class="list_setindex_designer_wrap">
          <div class="list_setindex_designer">
          
            <a class="item_setindex_designer"
              v-for="(item, index) in setDesigner" :key="index"
              :href="item.url"
            >
              <div class="avatar"
                v-lazy:background-image="{
                  src: item.avatar ? item.avatar : '/static/img/avatar_blank.png',
                  error: '/static/img/avatar_blank.png'
                }"
              ></div>
              <div class="name_wrap">
                <div class="name">{{item.name}}</div>
                <div class="subname">{{item.nickname}}</div>
                <div class="country">{{item.country}}</div>
              </div>
            </a>

            <div class="doufu"></div>
            
          </div>
        </div>
        
        
      
      </div>




      <div id="setindex_instruction" class="maincard_hasborder" v-if="setInstruction && setInstruction.length">
      
        <div class="main_title">
          <div class="title_wrap">
            <div class="title">图纸资源{{setInstruction.length ? "（"+ setInstruction.length +"）" : ""}}</div>
            <!--<a class="btn_more btn" href="./ridetrailtheme_list.html">更多主题</a>-->
          </div>
          <!--<div class="text">开车太快，走路太慢，骑车刚刚好。</div>-->
        </div>
        
        <div class="list_setindex_instruction_wrap" :class="{folded: setInstructionFolded}">
          <div class="list_setindex_instruction">
          
            <div class="item_setindex_instruction"
              v-for="(item, index) in setInstruction" :key="index"
            >
              <i class="cover" 
                v-lazy:background-image="item.cover"
                v-if="item.cover"
              ></i>
              <i class="icon material-icons" v-else>&#xe3db;</i>
              <div class="title_wrap">
                <div class="title">{{item.title}}</div>
                <div class="text">{{item.text}}</div>
              
                <template v-if="item.type=='pic'">
                  <div class="btn">复制链接</div>
                </template>
                <template v-else-if="item.type=='zip'">
                  <div class="btn" v-waves
                    v-for="(url_n, url_i) in item.data" :key="url_i"
                  >复制链接</div>
                </template>
                <template v-else-if="item.type=='ldd'">
                  <div class="btn" v-waves
                    v-for="(url_n, url_i) in item.data" :key="url_i"
                  >复制链接</div>
                </template>
                <template v-else-if="item.type=='url'">
                  <div class="btn" v-waves
                    v-for="(url_n, url_i) in item.data" :key="url_i"
                  >复制链接</div>
                </template>
                <template v-else-if="item.type=='pdf'">
                  <template v-if="$store.state.browser.wxminiprogram || $store.state.browser.bdminiprogram">
                    <a class="btn" v-waves
                      v-for="(url_n, url_i) in item.data" :key="url_i"
                      @click="copyText($store.state.siteUrl + '/goto?t=instruction&id=' + item.id + '&index=' + url_i)"
                    >复制链接</a>
                  </template>
                  <template v-else>
                    <router-link class="btn" v-waves
                      v-for="(url_n, url_i) in item.data" :key="url_i"
                      :to="{
                        name: 'Goto',
                        query: {
                          id: item.id,
                          t: 'instruction',
                          index: url_i
                          //url: item.url
                        }
                      }"
                    >查看PDF</router-link>
                  </template>
                </template>

              </div>
            </div>

          </div>
          <div class="card_more" v-if="setInstruction.length > 3" @click="foldAndScrollInstruction"><span v-if="setInstructionFolded">展开全部图纸列表</span><span v-else>折叠图纸列表</span></div>
        </div>
        <div class="main_tips">* 图纸资源来自于网络，仅供学习参考</div>
        
        
      
      </div>

      <div id="setindex_video" class="maincard_hasborder" v-if="setVideo && setVideo.length">
      
        <div class="main_title">
          <div class="title_wrap">
            <div class="title">视频{{setVideo.length ? "（"+ setVideo.length +"）" : ""}}</div>
          </div>
        </div>
        
        
        <div class="list_setindex_video_wrap">
          <div class="list_setindex_video">
          
            <a class="item_setindex_video" v-waves
              v-for="(item, index) in setVideo" :key="index"
              :href="'/Goto?url=' + encodeURIComponent(item.url)"
              @click.prevent.stop="previewVideo(index)"
            >
              <div class="cover_wrap">
                <div class="cover"
                  v-lazy:background-image="{
                    src: item.cover ? item.cover : '/static/img/img_blank.png',
                    error: '/static/img/img_blank.png'
                  }"
                  v-if="item.cover"
                ></div>
                <div class="cover nocover"
                   :style="{'background-color': 'hsl('+ (Math.random()*65) +'deg, 50%, 90%)'}"
                  v-else
                ><div class="textbg">{{item.title}}</div><i class="material-icons">&#xe038;</i><div class="video_duration" v-if="item.video_duration">{{item.video_duration}}</div></div>
              </div>
              <div class="title_wrap">
                <div class="title">{{item.title}}</div>
              </div>
            </a>

            <div class="doufu"></div>
            
          </div>
        </div>
        
        
      
      </div>
      
      
      <div id="setindex_article" class="maincard_hasborder" v-if="setArticle && (setVideo ? (setArticle.length - setVideo.length) : setArticle.length)">
      
        <div class="main_title">
          <div class="title_wrap">
            <div class="title">评测{{(setVideo ? (setArticle.length - setVideo.length) : setArticle.length) ? "（"+ (setVideo ? (setArticle.length - setVideo.length) : setArticle.length) +"）" : ""}}</div>
            <!--<a class="btn_more btn" href="./ridetrailtheme_list.html">更多主题</a>-->
          </div>
          <!--<div class="text">开车太快，走路太慢，骑车刚刚好。</div>-->
        </div>
        
        
        <div class="list_setindex_article_wrap" :class="{folded: setArticleFolded}">
          <div class="list_setindex_article">

            <template
              v-for="(item, index) in setArticle2"
            >
              <div class="item_setindex_article2"
                v-if="item.more"
                :key="index"
              >
                <div class="cover_wrap">
                  <div class="cover"
                    v-lazy:background-image="{
                      src: item.cover ? item.cover : '/static/img/img_blank.png',
                      error: '/static/img/img_blank.png'
                    }"
                    v-if="item.cover"
                  ></div>
                </div>
                <div class="item_setindex_article_box">
                  <div class="title_wrap_wrap">
                    <div class="title_wrap"
                      v-for="(from_n, from_i) in item.article"
                      :key="from_i"
                    >
                      <router-link class="title" v-waves
                        v-for="(n, i) in from_n.list"
                        :key="i"

                        :title="n.title"

                        :to="{
                          name: 'Goto',
                          query: {
                            //id: item.id
                            url: n.url
                          }
                        }"
                      ><i class="material-icons" v-if="n.tag==3">&#xe04a;</i><span v-if="n.type">【{{n.type}}】</span><span>{{n.title}}</span></router-link>
                      <div class="from" v-if="from_n.from">来自 {{from_n.from}}（{{from_n.list.length}} 篇）</div>
                    </div>
                  </div>
                  <div class="author_wrap"><div class="avatar" :style="{'background-color': 'rgb('+ Math.random()*255 +', '+ Math.random()*255 +', '+ Math.random()*255 +')'}" v-if="item.author"></div><div class="author">{{item.author}}</div></div>
                </div>
              </div>

              <router-link class="item_setindex_article" v-waves
                v-else
                :key="''+index"
                
                :to="{
                  name: 'Goto',
                  query: {
                    //id: item.id
                    url: item.url
                  }
                }"
              >
                <div class="cover_wrap">
                  <div class="cover"
                    v-lazy:background-image="{
                      src: item.cover ? item.cover : '/static/img/img_blank.png',
                      error: '/static/img/img_blank.png'
                    }"
                    v-if="item.cover"
                  ></div>
                </div>
                <div class="item_setindex_article_box">
                  <!-- <i class="favicon" style="background-image:url(https://bs-img.brick4.com/upload/favicon/smzdm.png)"></i> -->
                  <div class="title_wrap">
                    <div class="title"><i class="material-icons" v-if="item.tag==3">&#xe04a;</i><span v-if="item.type">【{{item.type}}】</span><span>{{item.title}}</span></div>
                    <div class="author_wrap" v-if="item.author || item.from"><!--<div class="avatar" 
                      v-lazy:background-image="{
                        src: item.avatar ? item.avatar : '/static/img/avatar_blank.png',
                        error: '/static/img/avatar_blank.png'
                      }"
                      v-if="item.avatar"
                    ></div>--><div class="avatar" :style="{'background-color': 'rgb('+ Math.random()*255 +', '+ Math.random()*255 +', '+ Math.random()*255 +')'}" v-if="item.author"></div><div class="author">{{item.author}}</div><div class="from" v-if="item.from">来自 {{item.from}}</div></div>
                  </div>
                </div>
              </router-link>

            </template>
            
          </div>
          <div class="card_more" v-if="setArticle.length > 5" @click="foldAndScrollArticle"><span v-if="setArticleFolded">展开全部评测列表</span><span v-else>折叠评测列表</span></div>
        </div>
        
        
        <div class="main_tips">* 文章言论仅代表其个人观点，与 积木小站 立场无关。</div>
      </div>






      <div id="setindex_shopping" class="maincard_hasborder" v-if="setShopping && setShopping.length">
      
        <div class="main_title">
          <div class="title_wrap">
            <div class="title">购买{{setShopping.length ? "（"+ setShopping.length +"）" : ""}}</div>
            <!--<a class="btn_more btn" href="./ridetrailtheme_list.html">更多主题</a>-->
          </div>
          <!--<div class="text">开车太快，走路太慢，骑车刚刚好。</div>-->
        </div>

        <div ref="price_timeflow" class="price_timeflow_echarts"></div>
        
        
        <div class="list_setindex_shopping">

          <template v-if="$store.state.browser.wxminiprogram || $store.state.browser.bdminiprogram">
            <!-- 小程序 复制链接 -->
            <div class="item_setindex_shopping"
              v-for="(item, index) in setShopping" :key="index"
              @mouseenter="changePriceflow(index)"
              @touchstart="changePriceflow(index)"
            >
              <div class="logo"
                v-lazy:background-image="{
                  src: item.logo ? item.logo : '/static/img/malllogo/blank.png',
                  error: '/static/img/malllogo/blank.png'
                }"
              ></div>
              <div class="title_wrap">
                <div class="title">{{item.site ? "【"+item.site+"】" : ""}}{{item.title}}</div>
                <div class="time">{{item.time}}</div>
              </div>
              <div class="price">{{item.price}}</div>
              <a class="btn btn_buy btn_color_2 btn_shadow" v-waves
                @click="copyText($store.state.siteUrl + '/shopping/' + item.id)"
              ><i class="material-icons">&#xe14d;</i><span>复制链接</span></a>
            </div>
          </template>

          <template v-else>
            <router-link class="item_setindex_shopping" v-waves
              target="_blank" rel="nofollow"
              v-for="(item, index) in setShopping" :key="index"
              :to="{
                name: 'SetGoshopping',
                params: {
                  id: item.id
                }
              }"
              @mouseenter.native="changePriceflow(index)"
              @touchstart.native="changePriceflow(index)"
            >
              <div class="logo"
                v-lazy:background-image="{
                  src: item.logo ? item.logo : '/static/img/malllogo/blank.png',
                  error: '/static/img/malllogo/blank.png'
                }"
              ></div>
              <div class="title_wrap">
                <div class="title">{{item.site ? "【"+item.site+"】" : ""}}{{item.title}}</div>
                <div class="time">{{item.time}}</div>
              </div>
              <div class="price">{{item.price}}</div>
              <i class="material-icons">&#xe5cc;</i>
            </router-link>
          </template>

          
        </div>
        
        <div class="main_tips">* 价格仅供参考，请以实际下单价格为准。</div>
      
      </div>



      <div id="setindex_relset" class="maincard_hasborder" v-if="setRelset && setRelset.length">
      
        <div class="main_title">
          <div class="title_wrap">
            <div class="title">关联套组{{setRelset.length ? "（"+ setRelset.length +"）" : ""}}</div>
            <!--<a class="btn_more btn" href="./ridetrailtheme_list.html">更多主题</a>-->
          </div>
          <!--<div class="text">开车太快，走路太慢，骑车刚刚好。</div>-->
        </div>
        
        
        <div class="list_setindex_relset_wrap" :class="{folded: setRelsetFolded}">
          <div class="list_setindex_relset">
          
            <router-link class="item_setindex_relset" v-waves
              :class="{active: item.setnumberid == setnumberId}"
              v-for="(item, index) in setRelset" :key="index"
              :to="(item.brandcode && item.setnumber && item.setnumber != '【未知】') ?
                {
                  name: 'SetIndex',
                  params: {
                    brand: item.brandcode,
                    setnumber: item.setnumber,
                  }
                }
                :
                {
                  name: 'SetIndexById',
                  params: {
                    id: item.setnumberid,
                  }
                }
              "
            >
              <!-- <div class="active"><div v-if="item.setnumberid == setnumberId">当前款</div></div> -->
              <div class="cover"
                v-lazy:background-image="{
                  src: item.cover ? item.cover : '/static/img/cover_blank.png',
                  loading: '/static/img/img_load.gif',
                  error: '/static/img/img_blank.png'
                }"
              ></div>
              <div class="title_wrap">
                <div class="brandandnumber"><div class="logo" 
                  v-lazy:background-image="{
                    src: item.brandlogo ? item.brandlogo : '/static/img/brand_blank.png',
                    error: '/static/img/brand_blank.png'
                  }"
                ></div><div class="brand">{{splitBrandText(item.brandtext)}}</div><div class="number">{{item.setnumber}}</div></div>
                <div class="title">{{item.remarks}}</div>
                <!-- <div class="title">{{item.title}}</div>
                <div class="remarks">{{item.remarks}}</div> -->
              </div>
            </router-link>
            
          </div>
          
          <div class="card_more" @click="setRelsetFolded=!setRelsetFolded" v-if="setRelset.length > 5"><span v-if="setRelsetFolded">展开全部</span><span v-else>折叠关联套组</span></div>
        </div>
      
      </div>
      
      
      
      
      <div id="setindex_recommendset" class="maincard_hasborder">
      
        <div class="main_title">
          <div class="title_wrap">
            <div class="title">其他推荐</div>
            <!--<a class="btn_more btn" href="./ridetrailtheme_list.html">更多主题</a>-->
          </div>
          <!--<div class="text">开车太快，走路太慢，骑车刚刚好。</div>-->
        </div>

        <div class="brandcard" v-if="setBrandDetail.logo">
          <div class="logo"
            v-lazy:background-image="{
              src: setBrandDetail.logo ? setBrandDetail.logo : '/static/img/brand_blank.png',
              error: '/static/img/brand_blank.png'
            }"
          ></div>
          <div class="title_wrap">
            <div class="title" :title="setBrandDetail.title">{{setBrandDetail.title}}</div>
            <router-link class="btn" v-waves
              :to="{
                name: 'BrandIndex', params: {id: setBrandDetail.id}
              }"
            >了解品牌</router-link>
            <router-link class="btn" v-waves
              :to="{
                name: 'SearchSet', query: {
                  brand: setBrandDetail.id,
                  theme: setTheme[setTheme.length-1].id,
                }
              }"
            >查看更多同主题的套组</router-link>
          </div>
        </div>
        
        <template v-if="setRecommendsetGetOver==1">
          <template v-if="setRecommendset && setRecommendset.length">
            <div class="list_setindex_recommendset">
            
              <router-link class="item_setindex_recommendset"
                v-for="(item, index) in setRecommendset" :key="index"
                :to="(item.brandcode && item.setnumber) ?
                  {
                    name: 'SetIndex',
                    params: {
                      brand: item.brandcode,
                      setnumber: item.setnumber,
                    }
                  }
                  :
                  {
                    name: 'SetIndexById',
                    params: {
                      id: item.setnumberid,
                    }
                  }
                "
              >
                <div class="item_setindex_recommendset_box" v-waves>
                  <div class="cover_wrap">
                    <div class="cover"
                      v-lazy:background-image="{
                        src: item.cover ? item.cover : '/static/img/cover_blank.png',
                        loading: '/static/img/img_load.gif',
                        error: '/static/img/img_blank.png'
                      }"
                    ></div>
                    <div class="sign sign_newrelease" v-if="item.sign_newrelease">
                      <span>新品</span>
                    </div>
                    <div class="sign sign_outofprint" v-else-if="item.sign_outofprint">
                      <span>{{item.sign_outofprintjust ? "绝版不久" : "已绝版"}}</span>
                    </div>
                    <div class="sign sign_outofprintsoon" v-else-if="item.sign_outofprintsoon">
                      <span>即将绝版</span>
                    </div>
                    <div class="sign sign_newadd" v-else-if="item.sign_newadd">
                      <span>新收录</span>
                    </div>
                  </div>
                  <div class="title_wrap">
                    <div class="theme">{{item.themetext}}</div>
                    <div class="title">{{item.title}}</div>
                    <!-- <div class="subtitle">{{item.subtitle}}</div> -->
                    <div class="brandandnumber"><div class="logo" 
                      v-lazy:background-image="{
                        src: item.brandlogo ? item.brandlogo : '/static/img/brand_blank.png',
                        error: '/static/img/brand_blank.png'
                      }"
                    ></div><div class="brand">{{splitBrandText(item.brandtext)}}</div><div class="number">{{item.setnumber}}</div></div>
                  </div>
                </div>
              </router-link>

              
            </div>
            
            <div class="nothing">
              <div><small>好玩的积木有很多，再去</small></div>
              <router-link class="btn" :to="{name: 'SearchSet'}">找找看</router-link>
            </div>

          </template>
          <div class="nothing" v-else>
            <i class="material-icons big">&#xe812;</i>
            <div>没啥推荐的了</div>
            <router-link class="btn" :to="{name: 'Index'}">去首页看看</router-link>
          </div>
        </template>

        <div class="nothing nothing_load" v-else-if="setRecommendsetGetOver==0">
          <i class="material-icons big">&#xe88b;</i>
          <div>等我一下</div>
          <div><small>再给你推荐点儿好东西……</small></div>
        </div>

        <div class="nothing" v-else>
          <i class="material-icons big">&#xe812;</i>
          <div>呃，在仓库迷路了</div>
          <a class="btn" @click="pageReload()">点击重新加载</a>
        </div>


        <div class="list_moresearch">
          <router-link class="btn"
            v-for="(item, index) in setSuggest" :key="index"
            :to="{name: 'SearchSet', query: item.query}"
          >{{item.text}}</router-link>
        </div>
      
      </div>



      <div id="setindex_footer">
      
        <div class="">本页涉及品牌商标属于其所有者。<br>用户言论仅代表其个人观点。<br>如果内容有误，<a @click="$refs.FloatTools.funFeedback()"><b>敬请反馈</b></a>。</div>
        
        
      
      </div>

    </div>
    <!-- 主体 结束 -->


    <!-- 底栏 开始 -->
    <div id="setindex_bottombar" class="bottombar" :class="{hasshow: !headerTransparent}" v-if="setShopping.length > 0">
      <div class="bottombar_box">

        <div class="bottombar_part price" v-if="setPriceLower > 0">¥{{setPriceLower}}<small>起</small><div class="ppp" title="零件均价" v-if="setDetail.pcs > 0">PPP：¥{{(setPriceLower / setDetail.pcs).toFixed(4)}}</div></div>
        <div class="bottombar_part price" v-else-if="setDetail.price > 0">¥{{setDetail.price}}<div class="ppp" title="零件均价" v-if="setDetail.pcs > 0">PPP：¥{{(setDetail.price / setDetail.pcs).toFixed(4)}}</div></div>
        <div class="bottombar_part price" v-else-if="setDetail.price_dollar > 0">${{setDetail.price_dollar}}</div>
        <div class="bottombar_part price" v-else>价格信息暂缺</div>

        <div class="bottombar_part">
          <a class="btn_inner btn btn_shadow btn_color_2 btn_round" :class="{disabled: setShopping.length == 0}" v-waves @click="changeTabnavGoodsDetail('#setindex_shopping')">
            <span>立即购买</span>
          </a>
        </div>
        
      </div>
    </div>
    <!-- 底栏 结束 -->

    <!-- 相册 开始 -->
    <van-popup
      v-model="showSubplateAlbum"
      position="bottom"
      class="subplate_album"
    >
      <div class="subplate_box">

        <div class="pic_list">
          <img
            v-for="(image, index) in setDetail.cover_arr" :key="index"
            v-lazy="{
              src: image,
              loading: '/static/img/img_load.gif',
              error: '/static/img/img_blank.png'
            }"
            @click="albumPreview(index)"
           />
        </div>

      </div>

      <div class="bottombar">
        <div class="bottombar_box">
          <div class="bottombar_part">
            <a class="btn_inner btn btn_shadow btn_color_4 btn_cancel btn_round" @click="showSubplateAlbum=false">
              <span>关闭</span>
            </a>
          </div>
        </div>
      </div>

    </van-popup>
    <!-- 相册 结束 -->

    <!-- 预览视频 开始 -->
    <van-popup
      v-model="showSubplateVideo"
      position="bottom"
      class="subplate_video"
    >
      <div class="subplate_box">
        <div>
          <iframe v-if="urlVideo" :src="urlVideo" scrolling="yes" border="0" frameborder="no" framespacing="0" allowfullscreen="true"> </iframe>
        </div>
      </div>

      <div class="bottombar">
        <div class="bottombar_box">
          <div class="bottombar_part">
            <a class="btn_inner btn btn_shadow btn_color_4 btn_cancel btn_round" @click="showSubplateVideo=false; urlVideo=''">
              <span>关闭</span>
            </a>
          </div>
        </div>
      </div>

    </van-popup>
    <!-- 预览视频 结束 -->

    <!-- 零件规格说明 开始 -->
    <BricktypeInfo ref="BricktypeInfo"></BricktypeInfo>
    <!-- 零件规格说明 结束 -->

    <!-- 右下角浮动按钮 开始 -->
    <FloatTools ref="FloatTools" :showScrollToTop="showScrollToTop">
      <template v-slot:extra>
      </template>
    </FloatTools>
    <!-- 右下角浮动按钮 结束 -->



    <!-- 本页二维码 开始 -->
    <PageQr ref="PageQr"></PageQr>
    <!-- 本页二维码 结束 -->




  </div>
</template>

<script>

import { ImagePreview } from "vant";

import VueBarcode from 'vue-barcode';

import BricktypeInfo from './BricktypeInfo'

export default {
  name: 'SetIndex',
  inject: ['pageReload'],
  components: {
    BricktypeInfo,

    'barcode': VueBarcode

    //CountDown,
    //GoodsReview,
    //GoodsDecision,//选择规格
    //StoreSelect,
    //StoreSelectLimitArea,
    //Coupon,

  },
  props: {},
  data () {
    return {

      input_nocache: this.$route.query.nc,//是否不走缓存，可用于刷新缓存

      showScrollToTop: false,//显示“滚动到页顶”

      tabScrollPostion: 0,//0 描述 1 评测 2 相关套组


      setRichtextFolded: true,//套组描述展开
      setRichtextTooLong: false,//套组描述太长了
      setRelsetFolded: false,//关联套组展开
      setInstructionFolded: false,//图纸展开
      setArticleFolded: false,//评测好文展开

      setnumberId: this.$route.params.id,//套组id
      setBrand: this.$route.params.brand,//套组品牌
      setNumber: this.$route.params.setnumber,//套组编号

      //service_shopno: false, //是否有服务门店

      //getGoodsOver: false,//商品详情是否已载入 false 载入中 true 已载入

      //goodsOffTheShelf: true,//商品是否已下架 false 上架 true 下架
      //goodsOnTheShelfTime: 0,//上架定时

      //goodsCoverAutoplay: 0,//3000,//头图自动滚动频率

      //goodsCoverVideo: '',//'https://giant-img.oss-cn-shanghai.aliyuncs.com/fileupload/20200424/158771462553051.mp4',//商品视频

      //coverVideoActive: false,//头图视频已触发
      //coverVideoPlaying: false,//头图视频播放中

      //coverIndicatorCurrent: 0,//头图当前序号

      hasParam: false,//是否有参数表
      showParam: false,//展开参数表

      setDetailGetOver: 0,//套组资料载入状态 0 载入中 1 成功 2 载入失败

      setDetailCoverIndex: 0,//当前显示的头图编号

      setPriceLower: 0,//最低价格

      coverAutoplay: 3000,//封面头图自动播放

      //套组基本信息
      setDetail: {
        cover_arr: [],
        //cover: '/static/img/img_blank.jpg',
        // title: 'NASA发现者号航天飞机',
        // subtitle: 'NASA Space Shuttle Discovery',
        // brandid: '1',
        // setnumber: '10283',
        // released_year: '2022',
        // pcs: '2354',
        // age_lower: '2',
        // age_upper: '20',
        // released: '2020-07-18',
        // outofprint: '2020-07-18',
        // weight: '1.28',
        // minifigs: '2',
        // package_size: '20x15x56',
        // size: '5x5x8',
        // package_type: '盒装',
        // remarks: '展示盒 内含4款',
        // ean: '6970556359300',
        // bricktype: 3,
        // text: "",
      },

      //当前品牌的信息
      setBrandDetail: {
        //"id": "1",
        //"title": "乐高LEGO",
        //"logo": "http://brick4.com/upload/brand/brand_1.png",
        //"code": "LEGO",
      },

      //主题系列面包屑
      setTheme: [
        // {
        //   url: "http://brick4.com/search/set?t=29",
        //   title: "学前教育",
        //   subtitle: "Pre-school",
        // },
        // {
        //   url: "http://brick4.com/search/set?t=147",
        //   title: "得宝",
        //   subtitle: "Duplo",
        // },
      ],

      //人仔
      setMinifigs: [

      ],

      //设计师
      setDesigner: [
        // {
        //   url: "http://brick4.com/search/set?t=29",
        //   avatar: "/static/demo/2020_12_19_19_49_53_23058500_967e521ce321ef3cdbaaa947aee40d67.jpg",
        //   name: "Milan Madge",
        //   subname: "MMC",
        // },
        // {
        //   url: "http://brick4.com/search/set?t=29",
        //   avatar: "/static/demo/2020_12_19_22_31_55_25065700_12e08116b18e4ea27138c670e2075582.jpg!setcover.webp",
        //   name: "Andrew Woodman",
        //   subname: "",
        // },
        // {
        //   url: "http://brick4.com/search/set?t=29",
        //   avatar: "/static/demo/2020_12_19_22_31_55_25065700_12e08116b18e4ea27138c670e2075582.jpg!setcover.webp",
        //   name: "Andrew Woodman",
        //   subname: "Pre-school",
        // },
      ],


      //图纸
      setInstruction: [
        // {
        //   "id": "3",
        //   "cover": "",
        //   "title": "乐高LEGO 42030 官方图纸",
        //   "text": "42030_X_42030 Articulated Hauler 1 of 3",
        //   "type": "zip",
        //   "url": "https://www.lego.com/cdn/product-assets/product.bi.core.pdf/6252563.pdf",
        // }
      ],


      //视频
      setVideo: [
        // {
        //   url: "http://brick4.com/search/set?t=29",
        //   cover: "/static/demo/58bf88afb474bf02c49d2c338e7a4c55f0004e16.jpg",
        //   title: "贫穷版《乐高马里奥》不买整套乐高也能玩",
        //   site: "bilibili",
        // },
        // {
        //   url: "http://brick4.com/search/set?t=29",
        //   cover: "/static/demo/2020_12_19_19_49_53_23058500_967e521ce321ef3cdbaaa947aee40d67.jpg",
        //   title: "Milan Madge",
        //   site: "Youku",
        // },
        // {
        //   url: "http://brick4.com/search/set?t=29",
        //   cover: "/static/demo/2020_12_19_19_49_53_23058500_967e521ce321ef3cdbaaa947aee40d67.jpg",
        //   title: "Milan Madge",
        //   site: "bilibili",
        // },
      ],

      //文章
      setArticle: [
        // {
        //   url: "http://brick4.com/search/set?t=29",
        //   cover: "/static/demo/58bf88afb474bf02c49d2c338e7a4c55f0004e16.jpg",
        //   title: "贫穷版《乐高马里奥》不买整套乐高也能玩",
        //   site: "bilibili",
        // },
        // {
        //   url: "http://brick4.com/search/set?t=29",
        //   cover: "/static/demo/2020_12_19_19_49_53_23058500_967e521ce321ef3cdbaaa947aee40d67.jpg",
        //   title: "Milan Madge",
        //   site: "Youku",
        // },
        // {
        //   url: "http://brick4.com/search/set?t=29",
        //   cover: "/static/demo/2020_12_19_19_49_53_23058500_967e521ce321ef3cdbaaa947aee40d67.jpg",
        //   title: "Milan Madge",
        //   site: "bilibili",
        // },
      ],
      setArticle2: [],

      //购物入口
      setShopping: [
        // {
        //   url: "http://brick4.com/search/set?t=29",
        //   time: "08-05 15:42",
        //   logo: "/static/demo/58bf88afb474bf02c49d2c338e7a4c55f0004e16.jpg",
        //   title: "热狗和热高热热狗",
        //   site: "拼多多",
        // },
        // {
        //   url: "http://brick4.com/search/set?t=29",
        //   time: "08-05 15:42",
        //   logo: "/static/demo/58bf88afb474bf02c49d2c338e7a4c55f0004e16.jpg",
        //   title: "热狗和热高热热狗",
        //   site: "拼多多",
        // },
        // {
        //   url: "http://brick4.com/search/set?t=29",
        //   time: "08-05 15:42",
        //   logo: "/static/demo/58bf88afb474bf02c49d2c338e7a4c55f0004e16.jpg",
        //   title: "热狗和热高热热狗",
        //   site: "拼多多",
        // },
      ],

      //关联套组
      setRelset: [
        // {
        //   url: "http://brick4.com/search/set?t=29",
        //   setid: "56",
        //   cover: "/static/demo/58bf88afb474bf02c49d2c338e7a4c55f0004e16.jpg",
        //   title: "贫穷版《乐高马里奥》不买整套乐高也能玩",
        //   brandlogo: 'http://brick4.com/upload/brand/brand_1.png',
        //   brandtext: '乐高 LEGO777777777777777777777777777777777777777777777777',
        //   setnumber: '111',
        //   remarks: "粉色",
        // },
        // {
        //   url: "http://brick4.com/search/set?t=29",
        //   setid: "56",
        //   cover: "/static/demo/2020_12_19_19_49_53_23058500_967e521ce321ef3cdbaaa947aee40d67.jpg",
        //   title: "Milan Madge",
        //   brandlogo: 'http://brick4.com/upload/brand/brand_1.png',
        //   brandtext: '乐高 LEGO',
        //   setnumber: '111',
        //   remarks: "",
        // },
        // {
        //   url: "http://brick4.com/search/set?t=29",
        //   setid: "56",
        //   cover: "/static/demo/2020_12_19_19_49_53_23058500_967e521ce321ef3cdbaaa947aee40d67.jpg",
        //   title: "Milan Madge",
        //   brandlogo: 'http://brick4.com/upload/brand/brand_1.png',
        //   brandtext: '乐高 LEGO',
        //   setnumber: '111',
        //   remarks: "蓝色",
        // },
      ],


      setRecommendsetGetOver: 0,//其他推荐套组载入状态 0 载入中 1 成功 2 载入失败

      //其他推荐套组
      setRecommendset: [
        // {
        //   title: 'NASA发现者号航天飞机',
        //   subtitle: 'NASA Gtrhtrertrge',
        //   link: './set_index.html',
        //   cover: './static/demo/58bf88afb474bf02c49d2c338e7a4c55f0004e16.jpg',
        //   brandlogo: 'http://brick4.com/upload/brand/brand_1.png',
        //   brandtext: '乐高 LEGO',
        //   setnumber: '111',
        // },
        // {
        //   title: 'NASA发现者号航天飞机',
        //   subtitle: 'NASA Gtrhtrertrge',
        //   link: './set_index.html',
        //   cover: './static/demo/58bf88afb474bf02c49d2c338e7a4c55f0004e16.jpg',
        //   brandlogo: 'http://brick4.com/upload/brand/brand_1.png',
        //   brandtext: '乐高 LEGO',
        //   setnumber: '222',
        // },
        // {
        //   title: 'NASA发现者号航天飞机',
        //   subtitle: 'NASA Gtrhtrertrge',
        //   link: './set_index.html',
        //   cover: './static/demo/58bf88afb474bf02c49d2c338e7a4c55f0004e16.jpg',
        //   brandlogo: 'http://brick4.com/upload/brand/brand_1.png',
        //   brandtext: '乐高 LEGO',
        //   setnumber: '10283',
        // },
        // {
        //   title: 'NASA发现者号航天飞机',
        //   subtitle: 'NASA Gtrhtrertrge',
        //   link: './set_index.html',
        //   cover: './static/demo/58bf88afb474bf02c49d2c338e7a4c55f0004e16.jpg',
        //   brandlogo: 'http://brick4.com/upload/brand/brand_1.png',
        //   brandtext: '乐高 LEGO',
        //   setnumber: '10283',
        // },
        // {
        //   title: 'NASA发现者号航天飞机',
        //   subtitle: 'NASA Gtrhtrertrge',
        //   link: './set_index.html',
        //   cover: './static/demo/58bf88afb474bf02c49d2c338e7a4c55f0004e16.jpg',
        //   brandlogo: 'http://brick4.com/upload/brand/brand_1.png',
        //   brandtext: '乐高 LEGO',
        //   setnumber: '10283',
        // },
      ],


      //搜索建议
      setSuggest: [

      ],

      // goods: {
      //   cover: [
      //     'https://e.giant.com.cn//uploads/admin/goods/98057bf649e6a10ea2813e0db5bba075.jpg',
      //     'https://e.giant.com.cn//uploads/admin/goods/1cc2bf333f5b596934e9f75c3b7a0cc9.jpg'
      //   ],//头图数组
      //   title: 'iNeed 卡布奇诺 舒心优雅城市休闲自行车',
      //   subtitle: '轻量化 碳纤轮组 空气力学设计 专业竞赛验证',
      // },



      //商品详情 图文内容
      //richtextDetail: '<img src="https://e.giant.com.cn/uploads/admin/kdr/image/20190110/20190110191632_82127.jpg" alt=""><img src="https://e.giant.com.cn/uploads/admin/kdr/image/20190110/20190110191632_64117.jpg" alt=""><img src="https://e.giant.com.cn/uploads/admin/kdr/image/20190110/20190110191632_32612.jpg" alt="">',

      //购物须知 图文内容
      //richtextShoppingtips: [
        // '<img src="https://gdp.alicdn.com/imgextra/i2/1810404213/O1CN01WXG6l21gzbC0OED0y_!!1810404213.jpg" alt="">',
      //],

      //图文内容页签切换
      //tabnavGoodsDetail: 0,

      //热门评论
      //goodsarticle: [
        // {
        //   author: {
        //     avatar: 'http://192.168.3.110/gmall/demo/img/avatar_demo01.jpg',
        //     name: '热辣朝天椒',
        //   },
        //   time: '2020/05/06 15:20',
        //   spec: '黑色、4S码',
        //   star: 3.5,
        //   text: '放心买吧，官网卖的东西不可能是假的。不过颜色没想象中那么亮',
        //   image: [
        //     'http://192.168.3.110/gmall/demo/img/goods_article_01.jpg',
        //     'http://192.168.3.110/gmall/demo/img/goods_article_02.jpg',
        //     'http://192.168.3.110/gmall/demo/img/goods_article_03.jpg',
        //     'http://192.168.3.110/gmall/demo/img/goods_article_04.jpg',
        //   ],
        // },

        // {
        //   author: {
        //     avatar: 'http://192.168.3.110/gmall/demo/img/avatar_demo02.jpg',
        //     name: 'hbgiant',
        //   },
        //   time: '2020/05/06 15:20',
        //   spec: '白色、5L码',
        //   star: 2,
        //   text: '五星好评，很正，非常好！卖家的送的小礼品也挺多，那个反光条我最喜欢。其它经验就是地址最好一步到位，要不这个装车的大箱子，一般轿车很勉强才能装下',
        //   image: [
        //   ],
        // },

      //],

      //评论数
      //goodsarticleCounter: 65,


      //相关商品
      //relgoodslist_data: [],


      //相册面板
      showSubplateAlbum: false,

      //预览视频
      showSubplateVideo: false,
      urlVideo: "",


      headerTransparent: true,//头部标题栏透明样式




      //价格曲线配置参数
      timeflow_option: {
        grid: {
          top: '5%',
          left: '1%',
          right: '1%',
          bottom: '1%',
          containLabel: true
        },
        tooltip: {
          trigger: "axis",
          //formatter: "{a}: <b>￥{c}</b><br>{a1}: <b>￥{c1}</b><br>{a2}: <b>￥{c2}</b>",
          formatter: function (value, index) {
            //console.log(value);
            
            var tmp = "<small>" + value[0].axisValueLabel + "</small><br>";
            
            if( value.length >= 4 ){
              //tmp += "<div style='color:#ef3a3a;'>" + value[3].seriesName + "：";
              //tmp += "<b>￥" + value[3].data[1] + "</b></div>";
              tmp += "<b style='color:#ef3a3a;'>￥" + value[3].data[1] + "</b>";

              // if( this.setDetail.pcs ){
              //   tmp += "<br>PPP：￥" + (value[3].data[1] / this.setDetail.pcs).toFixed(2);
              // }

            } else {
              //tmp += "--：";
              //tmp += "<b>--</b><br>";
              tmp += "<b>--</b>";
            }

            tmp += "<hr>";
            
            // for (let i = 0; i < 3; i++) {
            //   tmp += "<small>" + value[i].seriesName + "：";
            //   tmp += "￥" + value[i].data[1] + "</small><br>";
            // }
            
            tmp += "<small>" + value[0].seriesName + "：";
            tmp += "￥" + value[0].data[1] + "</small><br>";

            tmp += "<small>" + value[1].seriesName + "：";
            tmp += "￥" + value[1].data[1] + "</small><br>";

            tmp += "<small>" + value[2].seriesName + "：";
            tmp += "￥" + parseFloat((value[2].data[1] + value[1].data[1]).toFixed(2)) + "</small><br>";
            
            
            return tmp;
          },
          // axisPointer: {
          //   type: 'cross',
          //   animation: false,
          //   label: {
          //     backgroundColor: '#ccc',
          //     borderColor: '#aaa',
          //     borderWidth: 1,
          //     shadowBlur: 0,
          //     shadowOffsetX: 0,
          //     shadowOffsetY: 0,
          //     color: '#222'
          //   }
          // },
          backgroundColor: "#fff",
          extraCssText: 'box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);padding: 10px 15px;',
          textStyle: {
            color: "#666",
          },
        },
        // dataZoom: [{
        //     show: true,
        //     realtime: true,
        //     start: 50,
        //     end: 100
        //   },
        //   {
        //     type: "inside",
        //     realtime: true
        //   }
        // ],
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: [],
          axisLine: {
            show: false,
            lineStyle:{
              //color: "#666",
              width: 0
            }
          },
          axisLabel: {
            color: "#777",
            fontSize: 10
          },
          axisTick: {
            show: false
          }
        },
        yAxis: {
          axisLine: {
            lineStyle:{
              //color: "#666",
              width: 0
            }
          },
          splitLine: {
            lineStyle: {
              opacity: .2,
            }
          },
          axisLabel: {
            color: "#777",
            fontSize: 10
          },
          axisTick: {
            show: false
          },
          boundaryGap: [0, "10%"],
          //max: 5200,
          //min: 2000,
        },
        //color: ["#4E66FF", "rgba(73, 169, 238, .6)"], //"#49a9ee"//echarts_color,
        series: [
          {
            type: 'line',
            smooth: true,
            name: '平均价格',
            itemStyle: {
              color: '#333'
            },
            lineStyle: {
              width: 1,
              opacity: 0.2
            },
            symbol: 'none',
            data: []
          },
          {
            type: 'line',
            smooth: true,
            name: '最低价格',
            stack: 'bgm',
            itemStyle: {
            },
            lineStyle: {
              opacity: 0
            },
            areaStyle: {
              opacity: 0,
            },
            symbol: 'none',
            data: []
          },
          {
            type: 'line',
            smooth: true,
            name: '最高价格',
            stack: 'bgm',
            itemStyle: {
            },
            lineStyle: {
              opacity: 0
            },
            areaStyle: {
              color: '#ccc',
              opacity: 0.2,
              origin:"start"
            },
            symbol: 'none',
            data: []
          },
          {
            symbol: 'circle',
            type: 'line',
            smooth: false,
            name: '',
            itemStyle: {
              color: '#ef3a3a'
            },
            lineStyle: {
              width: 3,
            },
            areaStyle: {
              color: {
                  type: 'linear',
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [{
                      offset: 0, color: 'rgba(239,58,58,.2)' // 0% 处的颜色
                  }, {
                      offset: 1, color: 'rgba(239,58,58,0)' // 100% 处的颜色
                  }],
                  globalCoord: false // 缺省为 false
              }
            },
            data: []
          },
        ]
      },

    }
  },
  computed: {
  },
  watch: {},
  created() {
    const _this = this;

    // if( _this.setId > 0 ){//传参为套组ID

    // } else if( _this.setBrand && _this.setNumber ) {//传参为品牌+编号

    // } else {//缺少关键传参

    // }
    

    //载入套组详情
    _this.getSetDetail(function(){

      //页面标题
      document.title = _this.setDetail.title + ' - 积木小站';

      _this.funHasParam();//判断是否有参数表

      _this.$nextTick(function(){
        _this.checkRichtextFolded();//判断套组描述是否超长（需要在页面渲染完）
      });

      //微信小程序分享
      if(_this.$store.state.browser.wxminiprogram){
        wx.miniProgram.postMessage({ data: {
          shareTitle: document.title,
          shareImg: _this.setDetail.cover_arr.length ? _this.setDetail.cover_arr[0] : '',
        } });
      }

      //百度小程序分享
      if(_this.$store.state.browser.bdminiprogram){
        swan.webView.postMessage({ data: {
          shareTitle: document.title,
          shareImg: _this.setDetail.cover_arr.length ? _this.setDetail.cover_arr[0] : '',
        } });
      }

      // if( _this.setDetail.position ){
      //   _this.mapIni();
      // }

    });


    //载入相关人仔
    _this.getSetMinifigs(function(){});

    //载入相关设计师
    _this.getSetDesigner(function(){});

    //载入相关图纸
    _this.getSetInstruction(function(){
      if( _this.setInstruction.length > 3 ){
        _this.setInstructionFolded = true;
      } else {
        _this.setInstructionFolded = false;
      }
    });

    //载入相关视频
    //_this.getSetVideo(function(){});

    //载入相关文章
    _this.getSetArticle(function(){
      if( _this.setArticle.length > 5 ){
        _this.setArticleFolded = true;
      } else {
        _this.setArticleFolded = false;
      }
    });

    //载入相关购物入口
    _this.getSetShopping(function(timeflow){

      _this.$nextTick(() => {

        // 绘制图表
        window.addEventListener("resize", () => {
          _this.price_timeflow_ech.resize();
        });

        //取最小值
        let tmpLow = 0;

        //将最大值设置为与最小值的差值
        timeflow.high.forEach(function(n, i){
          n[1] = n[1] - timeflow.low[i][1];

          if( timeflow.low[i][1] <= tmpLow || tmpLow == 0 ){
            tmpLow = timeflow.low[i][1];
          }
        });

        if( tmpLow <= 200 ){
          _this.timeflow_option.yAxis.min = 0;
        } else {
          _this.timeflow_option.yAxis.min = parseInt(tmpLow - 100);
        }
        //console.log(_this.timeflow_option.yAxis.min);

        _this.timeflow_option.xAxis.data = timeflow.date;
        _this.timeflow_option.series[0].data = timeflow.average;
        _this.timeflow_option.series[1].data = timeflow.low;
        _this.timeflow_option.series[2].data = timeflow.high;


        // if( _this.setShopping.length ){
        //   _this.timeflow_option.series[3].name = (_this.setShopping[0].site ? "【"+_this.setShopping[0].site+"】" : "") + _this.setShopping[0].title;
        //   _this.timeflow_option.series[3].data = _this.setShopping[0].timeflow;
        // }
  
        //console.log(_this.$refs.price_timeflow);
  
        _this.price_timeflow_ech = _this.$echarts.init(_this.$refs.price_timeflow);
        //_this.price_timeflow_ech.setOption(_this.timeflow_option);

        _this.changePriceflow(0);

      });

    });

    //载入关联套组
    _this.getSetRelset(function(){
      if( _this.setRelset.length > 5 ){
        _this.setRelsetFolded = true;
      } else {
        _this.setRelsetFolded = false;
      }
    });

    //载入其他推荐套组
    _this.getSetRecommendset(function(){});

  },
  mounted() {
    const _this = this;
    
    //_this.checkRichtextFolded();//判断套组描述是否超长
  
  
    //_this.mapIni();
    // console.log("in", _this.setNumber);
    // if( _this.setDetail.position ){
    //   _this.mapIni();
    // }






  
  },
  destroyed() {},
  methods: {


    //初始化地图
    // mapIni(){
    //   const _this = this;

    //   let tmpPosition = _this.setDetail.position.split(",");
    //   if( tmpPosition.length != 2 ){
    //     _this.setDetail.position = "";
    //     return false;
    //   }

    //   if( typeof(BMapGL) == "undefined" || BMapGL == null ){
    //     var url = 'https://api.map.baidu.com/api?type=webgl&v=1.0&ak=wnw8zVqztijGLcPqbPgZ7Ihe&callback=mapOnLoad';
    //     var jsapi = document.createElement('script');
    //     jsapi.charset = 'utf-8';
    //     jsapi.src = url;
    //     document.head.appendChild(jsapi);
    //   }
    //   console.log(1, _this.setNumber)
    //   // 设置地图类型为地球模式
    //   _this.mapIni2();

    // },

    //初始化地图 第二部分
    // mapIni2(){
    //   const _this = this;

    //   if( typeof(BMapGL) == "undefined" || BMapGL == null || !document.getElementById("map_container") ){
    //     _this.timeoutMapBaidu = setInterval(function(){
    //       _this.mapIni2();
    //     }, 500);
    //   } else {
    //     console.log(2, _this.setNumber)
    //     clearInterval(_this.timeoutMapBaidu);
    //     _this.mapBaidu = new BMapGL.Map('map_container'); // 创建Map实例
    //     let tmpPosition = _this.setDetail.position.split(",");
    //     let pointLandmrk = new BMapGL.Point(tmpPosition[0], tmpPosition[1]);
    //     _this.mapBaidu.centerAndZoom(pointLandmrk, 1);

    //     _this.mapBaidu.setMapType(BMAP_EARTH_MAP);

    //     let markerLandmrk = new BMapGL.Marker(pointLandmrk);//创建标注

    //     if( _this.setDetail.position_img ){
    //       let myIconBg = new BMapGL.Icon(
    //         _this.$store.state.api.common + "landmark/pin?img=" + encodeURIComponent(_this.setDetail.position_img), 
    //         new BMapGL.Size(80, 80),
    //         {
    //           anchor: new BMapGL.Size(40, 75),
    //         }
    //       );
    //       markerLandmrk.setIcon(myIconBg);
    //     }

    //     _this.mapBaidu.addOverlay(markerLandmrk);
    //   } 
    // },



    //标题“模型比例”处理 type 0 标题 1 比例
    titleScale(type){
      const _this = this;
      if( _this.setDetail.title ){
        if( type ){//比例
          if( _this.setDetail.scale ){
            return "1:" + _this.setDetail.scale;
          } else {
            let tmpScale = _this.setDetail.title.match(/[^\d](1:\d+)/g);
            if( tmpScale && tmpScale.length ){
              return tmpScale[0];
            } else {
              return "";
            }
          }
        } else {//标题
          return _this.setDetail.title.replace(/1:\d+/g, "").replace(/(^\s*)|(\s*$)/g, "");
        }
      } else {
        return "";
      }

    },


    //人仔数计算
    countMinifigs(){
      const _this = this;
      let tmpA = (_this.setMinifigs && _this.setMinifigs.length > 0) ? _this.setMinifigs.length : 0;
      let tmpB = (_this.setDetail && _this.setDetail.minifigs > 0) ? parseInt(_this.setDetail.minifigs) : 0;

      if( tmpA > tmpB && tmpB > 0 ){
        return "（"+ tmpB + "~" + tmpA +"）";
      } else if( tmpA < tmpB && tmpA > 0 ){
        return "（"+ tmpA + "~" + tmpB +"）";
      } else if( tmpA > 0 ){
        return "（"+ tmpA +"）";
      } else if( tmpB > 0 ){
        return "（"+ tmpB +"）";
      } else {
        return "";
      }

    },


    //复制
    copyText(text){
      const _this = this;

      // try {
      //   navigator.clipboard && navigator.clipboard.writeText(text).then(() => {
      //     //_this.$toast("复制成功，请自行前往浏览器粘贴打开");

      //     _this.$dialog.confirm({
      //       closeOnPopstate: true,//页面回退时自动关闭
      //       title: '复制成功',
      //       message: '请自行前往浏览器粘贴打开',
      //       confirmButtonText: '确定',
      //       showCancelButton: false
      //     }).then(() => {
      //     }).catch(() => {
      //     });

      //   });
      // }
      // catch (e) {
      //   _this.$toast("复制失败")
      // }

      _this.copyToClipboard(text);

      _this.$dialog.confirm({
        closeOnPopstate: true,//页面回退时自动关闭
        title: '复制成功',
        message: '请自行前往浏览器粘贴打开',
        confirmButtonText: '确定',
        showCancelButton: false
      }).then(() => {
      }).catch(() => {
      });

    },
    
    funPageScroll(data){
      const _this = this;
      //console.log(data.scrollTop);
      //console.log(data.isFixed);

      //头部标题栏透明样式粘性切换
      if( data.scrollTop > 100 ){
        _this.headerTransparent = false;
      } else {
        _this.headerTransparent = true;
      }
      //_this.headerTransparent = !data.isFixed;


      //是否显示滚到顶部
      if( data.scrollTop > 100 ){
        _this.showScrollToTop = true;
      } else {
        _this.showScrollToTop = false;
      }




      //滚动到不同位置切换 TAB 当前
      let clientHeight = document.documentElement.clientHeight || document.body.clientHeight;//获取浏览器可视区的高度
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;//获取窗口滚动条高度
      let offsetTop_0, offsetTop_1, offsetTop_2;
      let offsetTop_Main = document.querySelector("#setindex_main").offsetTop;

      let headerHeight = document.querySelector('.common_header').offsetHeight + document.querySelector('.tab_nav').offsetHeight;

      if( document.querySelector('#setindex_describe') ){
        offsetTop_0 = offsetTop_Main + document.querySelector('#setindex_describe').offsetTop + document.querySelector('#setindex_describe').offsetHeight - headerHeight;
      }
      if( document.querySelector('#setindex_article') ){
        offsetTop_1 = offsetTop_Main + document.querySelector('#setindex_article').offsetTop - headerHeight;
      }
      if( document.querySelector('#setindex_relset') ){
        offsetTop_2 = offsetTop_Main + document.querySelector('#setindex_relset').offsetTop - headerHeight;
      } else {
        offsetTop_2 = offsetTop_Main + document.querySelector('#setindex_recommendset').offsetTop - headerHeight;
      }

      // console.log(scrollTop >= offsetTop_0 , scrollTop < offsetTop_1, scrollTop, offsetTop_0 , offsetTop_1);
      //console.log(scrollTop, offsetTop_Main + document.querySelector('#setindex_article').offsetTop, offsetTop_2);

      

      if( offsetTop_0 && scrollTop < offsetTop_0 ){
        _this.tabScrollPostion = 0;
      } else if( offsetTop_0 && offsetTop_1 && scrollTop >= offsetTop_0 && scrollTop < offsetTop_2 ){
        _this.tabScrollPostion = 1;
      } else if( offsetTop_2 && scrollTop >= offsetTop_2 ){
        _this.tabScrollPostion = 2;
      }


    },


    //点击TAB签滚动至相应位置
    changeTabnavGoodsDetail(data){
      const _this = this;

      if( data == '#setindex_relset' && !document.querySelector('#setindex_relset') ){
        data = '#setindex_recommendset';
      }

      let headerHeight = document.querySelector('.common_header').offsetHeight + document.querySelector('.tab_nav').offsetHeight;

      //let targetTop = document.querySelector(data).offsetTop - 90;
      //let targetTop = document.querySelector(data).style.top;
      //let targetTop = document.querySelector(data).scrollTop;
      //let targetTop = document.querySelector(data).clientTop;
      let targetTop = document.querySelector("#setindex_main").offsetTop + document.querySelector(data).offsetTop - headerHeight;

      //console.log(targetTop);

      // let targetTop = document.querySelector('#richtext_promotion').offsetTop - 90;
      // if( data == 1 ){
      //   targetTop = document.querySelector('#richtext_attributes').offsetTop - 100;
      // } else if( data == 2 ){
      //   targetTop = document.querySelector('#richtext_shoppingtips').offsetTop - 100;
      // }

      if( data == "#setindex_shopping" ){
        targetTop -= 50;
      }

      _this.scrollToTop(300, targetTop);//滚动
    },




    //载入套组详情 开始 ==========================
    getSetDetail(callback){
      const _this = this;

      let tmpParams = {
        ///setid: _this.setId,
        //user_id: _this.$store.state.loginUser.sessionkey,
        nc: _this.input_nocache,
      };
      
      if( _this.setnumberId > 0 ){//传参为套组ID
        tmpParams.setnumberid = _this.setnumberId;
      } else if( _this.setBrand && _this.setNumber ) {//传参为品牌+编号
        tmpParams.setbrand = _this.setBrand;
        tmpParams.setnumber = _this.setNumber;
      } else {//缺少关键传参
        //
      }

      _this.axios.post(_this.$store.state.api.common + 'set/detail/', _this.qs.stringify(tmpParams)).then(function(res){
        if( res.status == 200 ){
          if( typeof res.data != "object" ){
            try{
              res.data = JSON.parse(res.data);
            } catch(error) {
              _this.$dialog.confirm({
                closeOnPopstate: true,//页面回退时自动关闭
                title: '载入套组详情失败',
                message: '您可以尝试：',
                confirmButtonText: '刷新重试',
                cancelButtonText: window.history.length > 1 ? '返回上一页' : '前往首页'
              }).then(() => {
                location.reload(true);
              }).catch(() => {
                window.history.length > 1 ? history.back() : _this.$router.replace({ path: '/'});
              });
              console.error(error);
              return false;
            }
          }
          if( res.data.status == 1 ){

            _this.setDetailGetOver = 1;//详情已载入

            let fatch_data = res.data.data;

            _this.setnumberId = fatch_data.id;

            // if( fatch_data.cover ){
            //   fatch_data.cover = _this.$store.state.api.img + fatch_data.cover + '!setcover';
            // }

            fatch_data.cover_arr.forEach(function(cover_n, cover_i, arr){

              if( cover_n ){
                arr[cover_i] = _this.$store.state.api.img + cover_n + '!setcover.webp';
                if( fatch_data.position && !fatch_data.position_img ){
                  fatch_data.position_img = _this.$store.state.api.img + cover_n + '?imageMogr2/extent/!60x60/thumbnail/60x60';
                }
              }

            });

            if( fatch_data.brand.logo ){
              fatch_data.brand.logo = _this.$store.state.api.img + fatch_data.brand.logo + '!brand_s';
            }

            _this.setDetail = fatch_data;
            _this.setBrandDetail = fatch_data.brand;
            _this.setTheme = fatch_data.theme.reverse();

            _this.setBrand = _this.setBrandDetail.code;
            _this.setNumber = _this.setDetail.setnumber;


            //更多的搜索建议
            if( fatch_data.suggest && fatch_data.suggest.length ){
              _this.setSuggest = fatch_data.suggest;
            }

            //优化视频
            //_this.setDetail.text = _this.setDetail.text.replace(/<a href="([^\"]+)" class="video">([^<]+)<\/a>/, '<video preload="auto" controls="controls" autoplay="" style=""><source src="$1" type="video/mp4"></video>');
            _this.setDetail.text = _this.setDetail.text.replace(/<a href="([^\"]+)" class="video">([^<]+)<\/a>/, '<video preload="auto" controls="controls"><source src="$1" type="video/mp4"></video>');


            //console.log(_this.setDetail);
            callback && callback();

          }else{
            _this.setDetailGetOver = 2;//详情载入失败
            _this.$dialog.confirm({
              closeOnPopstate: true,//页面回退时自动关闭
              title: res.data.msg ? res.data.msg : '载入套组详情，出现了一些问题',
              message: '您可以尝试：',
              confirmButtonText: '刷新重试',
              cancelButtonText: window.history.length > 1 ? '返回上一页' : '前往首页'
            }).then(() => {
              location.reload(true);
            }).catch(() => {
              window.history.length > 1 ? history.back() : _this.$router.replace({ path: '/'});
            });
          }
        }else{
          _this.setDetailGetOver = 2;//详情载入失败
          _this.$dialog.confirm({
            closeOnPopstate: true,//页面回退时自动关闭
            title: '套组详情拉取失败',
            message: '您可以尝试：',
            confirmButtonText: '刷新重试',
            cancelButtonText: window.history.length > 1 ? '返回上一页' : '前往首页'
          }).then(() => {
            location.reload(true);
          }).catch(() => {
            window.history.length > 1 ? history.back() : _this.$router.replace({ path: '/'});
          });
        }
      }).catch(function (error) {
        console.error(error);

        _this.setDetailGetOver = 2;//详情载入失败

        _this.$dialog.confirm({
          closeOnPopstate: true,//页面回退时自动关闭
          title: '网络不畅，详情拉取失败',
          message: '您可以尝试：',
          confirmButtonText: '刷新重试',
          cancelButtonText: window.history.length > 1 ? '返回上一页' : '前往首页'
        }).then(() => {
          location.reload(true);
        }).catch(() => {
          window.history.length > 1 ? history.back() : _this.$router.replace({ path: '/'});
        });


      });

    },
    //载入套组详情 结束 ==========================


    //判断是否有参数表
    funHasParam(){
      const _this = this;
      if(
        _this.setDetail.released
        || _this.setDetail.outofprint
        || _this.setDetail.weight
        || _this.setDetail.minifigs
        || _this.setDetail.package_size
        || _this.setDetail.package_type
        || _this.setDetail.size
        || _this.setDetail.ean
        || _this.setDetail.remarks
      ){
        _this.hasParam = true;
      } else {
        _this.hasParam = false;
      }
    },

    //判断套组描述是否超长
    checkRichtextFolded(){
      const _this = this;
      //console.log( _this.$refs.set_text_wrap.offsetHeight  );
      //console.log( _this.$refs.set_text.offsetHeight  );

      setTimeout(function(){
        if( _this.$refs.set_text && _this.$refs.set_text_wrap && _this.$refs.set_text.offsetHeight <= _this.$refs.set_text_wrap.offsetHeight ){
          _this.setRichtextFolded = false;//套组描述比较短，直接展开
        } else {
          _this.setRichtextTooLong = true;//套组描述太长了
        }
      }, 500);

      //console.log( window.getComputedStyle(_this.$refs.set_text_wrap).height );
      //console.log( window.getComputedStyle(_this.$refs.set_text).height );
    },
    //折叠套组描述并滚动到合适的位置
    foldAndScrollRichtext(){
      const _this = this;
      if( _this.setRichtextFolded ){
        _this.setRichtextFolded = false;
      } else {
        _this.setRichtextFolded = true;

        let headerHeight = document.querySelector('.common_header').offsetHeight + document.querySelector('.tab_nav').offsetHeight;
        let targetTop = document.querySelector("#setindex_main").offsetTop + document.querySelector("#setindex_describe").offsetTop - headerHeight;
        //_this.scrollToTop(300, targetTop);

        _this.scrollToTop(300, targetTop);
      }
    },

    //头图轮播
    setDetailCoverChange(index){
      const _this = this;
      _this.setDetailCoverIndex = index;
    },

    //查看大图
    // coverPreview(){
    //   const _this = this;
    //   //console.log(5);
    //   ImagePreview({
    //     images: _this.setDetail.cover_arr,
    //     startPosition: _this.setDetailCoverIndex,
    //     onClose: function(data){
    //       //console.log(data);
    //       _this.$refs.bigcover.swipeTo(data.index);
    //     },
    //   });

    // },



    // 用于判断滑动还是点击
    onTouchStart(e) {
      // this.clickIndex = 0; // 为了兼容安卓部分情况而加，如果不需要可忽略
      this.clickFlag = false;
    },
    // 用于判断滑动还是点击
    onTouchMove(e) {
      this.clickFlag = true;
      // 为了兼容安卓部分情况而加的判断，如果不需要可忽略，若需要，注释上面一行代码，打开下面三行代码
      // this.clickIndex = this.clickIndex + 1;
      // if (this.clickIndex > 2) {
      //   this.clickFlag = true;
      // }
    },
    coverPreview() {
      const _this = this;
      if (this.clickFlag) { // 滑动
        // console.log('滑动');
      } else { // 点击
        // console.log('点击');
        _this.coverAutoplay = 0;
        ImagePreview({
          images: _this.setDetail.cover_arr,
          startPosition: _this.setDetailCoverIndex,
          closeOnPopstate: true,
          onClose: function(data){
            //console.log(data);
            if( _this.$refs.bigcover ){
              _this.$refs.bigcover.swipeTo(data.index);
              setTimeout(function(){
                _this.coverAutoplay = 3000;
              }, 3000);
            }
          },
        });
      }
    },



    //载入相关人仔 开始 ==========================
    getSetMinifigs(callback){
      const _this = this;

      let tmpParams = {
        ///setid: _this.setId,
        //user_id: _this.$store.state.loginUser.sessionkey,
      };
      
      if( _this.setnumberId > 0 ){//传参为套组ID
        tmpParams.setnumberid = _this.setnumberId;
      } else if( _this.setBrand && _this.setNumber ) {//传参为品牌+编号
        tmpParams.setbrand = _this.setBrand;
        tmpParams.setnumber = _this.setNumber;
        if( _this.setBrand != "lego" ){
          //如果不是乐高品牌则离开
          return false;
        }
        if( _this.setNumber == "【未知】" || _this.setNumber == "无" || _this.setNumber == "" ){
          //如果没有编号则离开
          return false;
        }
      } else {//缺少关键传参
        //
        return false;
      }

      _this.axios.post(_this.$store.state.api.common + 'set/minifigs/', _this.qs.stringify(tmpParams)).then(function(res){
        if( res.status == 200 ){
          if( typeof res.data != "object" ){
            try{
              res.data = JSON.parse(res.data);
            } catch(error) {
              // _this.$dialog.confirm({
              //   closeOnPopstate: true,//页面回退时自动关闭
              //   title: '载入套组详情失败',
              //   message: '您可以尝试：',
              //   confirmButtonText: '刷新重试',
              //   cancelButtonText: window.history.length > 1 ? '返回上一页' : '前往首页'
              // }).then(() => {
              //   location.reload(true);
              // }).catch(() => {
              //   window.history.length > 1 ? history.back() : _this.$router.replace({ path: '/'});
              // });
              console.error(error);
              return false;
            }
          }
          if( res.data.status == 1 ){

            let fatch_data = res.data.data;

            _this.setMinifigs = [];

            fatch_data.forEach(function(minifig_n){

              // if( minifig_n.avatar ){
              //   minifig_n.avatar = _this.$store.state.api.img + minifig_n.avatar + '!setlist.webp';
              // }

              _this.setMinifigs.push(minifig_n);

            });

            //console.log(_this.setDesigner);
            callback && callback();

          }else{
            // _this.$dialog.confirm({
            //   closeOnPopstate: true,//页面回退时自动关闭
            //   title: res.data.msg ? res.data.msg : '载入套组详情，出现了一些问题',
            //   message: '您可以尝试：',
            //   confirmButtonText: '刷新重试',
            //   cancelButtonText: window.history.length > 1 ? '返回上一页' : '前往首页'
            // }).then(() => {
            //   location.reload(true);
            // }).catch(() => {
            //   window.history.length > 1 ? history.back() : _this.$router.replace({ path: '/'});
            // });
          }
        }else{
          // _this.$dialog.confirm({
          //   closeOnPopstate: true,//页面回退时自动关闭
          //   title: '套组详情拉取失败',
          //   message: '您可以尝试：',
          //   confirmButtonText: '刷新重试',
          //   cancelButtonText: window.history.length > 1 ? '返回上一页' : '前往首页'
          // }).then(() => {
          //   location.reload(true);
          // }).catch(() => {
          //   window.history.length > 1 ? history.back() : _this.$router.replace({ path: '/'});
          // });
        }
      }).catch(function (error) {
        console.error(error);

        // _this.$dialog.confirm({
        //   closeOnPopstate: true,//页面回退时自动关闭
        //   title: '网络不畅，详情拉取失败',
        //   message: '您可以尝试：',
        //   confirmButtonText: '刷新重试',
        //   cancelButtonText: window.history.length > 1 ? '返回上一页' : '前往首页'
        // }).then(() => {
        //   location.reload(true);
        // }).catch(() => {
        //   window.history.length > 1 ? history.back() : _this.$router.replace({ path: '/'});
        // });


      });

    },
    //载入相关人仔 结束 ==========================



    //载入相关设计师 开始 ==========================
    getSetDesigner(callback){
      const _this = this;

      let tmpParams = {
        ///setid: _this.setId,
        //user_id: _this.$store.state.loginUser.sessionkey,
      };
      
      if( _this.setnumberId > 0 ){//传参为套组ID
        tmpParams.setnumberid = _this.setnumberId;
      } else if( _this.setBrand && _this.setNumber ) {//传参为品牌+编号
        tmpParams.setbrand = _this.setBrand;
        tmpParams.setnumber = _this.setNumber;
      } else {//缺少关键传参
        //
      }

      _this.axios.post(_this.$store.state.api.common + 'set/designer/', _this.qs.stringify(tmpParams)).then(function(res){
        if( res.status == 200 ){
          if( typeof res.data != "object" ){
            try{
              res.data = JSON.parse(res.data);
            } catch(error) {
              // _this.$dialog.confirm({
              //   closeOnPopstate: true,//页面回退时自动关闭
              //   title: '载入套组详情失败',
              //   message: '您可以尝试：',
              //   confirmButtonText: '刷新重试',
              //   cancelButtonText: window.history.length > 1 ? '返回上一页' : '前往首页'
              // }).then(() => {
              //   location.reload(true);
              // }).catch(() => {
              //   window.history.length > 1 ? history.back() : _this.$router.replace({ path: '/'});
              // });
              console.error(error);
              return false;
            }
          }
          if( res.data.status == 1 ){

            let fatch_data = res.data.data;

            _this.setDesigner = [];

            fatch_data.forEach(function(designer_n){

              if( designer_n.avatar ){
                designer_n.avatar = _this.$store.state.api.img + designer_n.avatar + '!setlist.webp';
              }

              _this.setDesigner.push(designer_n);

            });

            //console.log(_this.setDesigner);
            callback && callback();

          }else{
            // _this.$dialog.confirm({
            //   closeOnPopstate: true,//页面回退时自动关闭
            //   title: res.data.msg ? res.data.msg : '载入套组详情，出现了一些问题',
            //   message: '您可以尝试：',
            //   confirmButtonText: '刷新重试',
            //   cancelButtonText: window.history.length > 1 ? '返回上一页' : '前往首页'
            // }).then(() => {
            //   location.reload(true);
            // }).catch(() => {
            //   window.history.length > 1 ? history.back() : _this.$router.replace({ path: '/'});
            // });
          }
        }else{
          // _this.$dialog.confirm({
          //   closeOnPopstate: true,//页面回退时自动关闭
          //   title: '套组详情拉取失败',
          //   message: '您可以尝试：',
          //   confirmButtonText: '刷新重试',
          //   cancelButtonText: window.history.length > 1 ? '返回上一页' : '前往首页'
          // }).then(() => {
          //   location.reload(true);
          // }).catch(() => {
          //   window.history.length > 1 ? history.back() : _this.$router.replace({ path: '/'});
          // });
        }
      }).catch(function (error) {
        console.error(error);

        // _this.$dialog.confirm({
        //   closeOnPopstate: true,//页面回退时自动关闭
        //   title: '网络不畅，详情拉取失败',
        //   message: '您可以尝试：',
        //   confirmButtonText: '刷新重试',
        //   cancelButtonText: window.history.length > 1 ? '返回上一页' : '前往首页'
        // }).then(() => {
        //   location.reload(true);
        // }).catch(() => {
        //   window.history.length > 1 ? history.back() : _this.$router.replace({ path: '/'});
        // });


      });

    },
    //载入相关设计师 结束 ==========================

    //载入相关图纸 开始 ==========================
    getSetInstruction(callback){
      const _this = this;

      let tmpParams = {
        ///setid: _this.setId,
        //user_id: _this.$store.state.loginUser.sessionkey,
      };
      
      if( _this.setnumberId > 0 ){//传参为套组ID
        tmpParams.setnumberid = _this.setnumberId;
      } else if( _this.setBrand && _this.setNumber ) {//传参为品牌+编号
        tmpParams.setbrand = _this.setBrand;
        tmpParams.setnumber = _this.setNumber;
      } else {//缺少关键传参
        //
      }

      _this.axios.post(_this.$store.state.api.common + 'set/instruction/', _this.qs.stringify(tmpParams)).then(function(res){
        if( res.status == 200 ){
          if( typeof res.data != "object" ){
            try{
              res.data = JSON.parse(res.data);
            } catch(error) {
              // _this.$dialog.confirm({
              //   closeOnPopstate: true,//页面回退时自动关闭
              //   title: '载入套组详情失败',
              //   message: '您可以尝试：',
              //   confirmButtonText: '刷新重试',
              //   cancelButtonText: window.history.length > 1 ? '返回上一页' : '前往首页'
              // }).then(() => {
              //   location.reload(true);
              // }).catch(() => {
              //   window.history.length > 1 ? history.back() : _this.$router.replace({ path: '/'});
              // });
              console.error(error);
              return false;
            }
          }
          if( res.data.status == 1 ){

            let fatch_data = res.data.data;

            _this.setInstruction = [];

            fatch_data.forEach(function(instruction_n){

              _this.setInstruction.push(instruction_n);

            });
            callback && callback();

          }else{
            // _this.$dialog.confirm({
            //   closeOnPopstate: true,//页面回退时自动关闭
            //   title: res.data.msg ? res.data.msg : '载入套组详情，出现了一些问题',
            //   message: '您可以尝试：',
            //   confirmButtonText: '刷新重试',
            //   cancelButtonText: window.history.length > 1 ? '返回上一页' : '前往首页'
            // }).then(() => {
            //   location.reload(true);
            // }).catch(() => {
            //   window.history.length > 1 ? history.back() : _this.$router.replace({ path: '/'});
            // });
          }
        }else{
          // _this.$dialog.confirm({
          //   closeOnPopstate: true,//页面回退时自动关闭
          //   title: '套组详情拉取失败',
          //   message: '您可以尝试：',
          //   confirmButtonText: '刷新重试',
          //   cancelButtonText: window.history.length > 1 ? '返回上一页' : '前往首页'
          // }).then(() => {
          //   location.reload(true);
          // }).catch(() => {
          //   window.history.length > 1 ? history.back() : _this.$router.replace({ path: '/'});
          // });
        }
      }).catch(function (error) {
        console.error(error);

        // _this.$dialog.confirm({
        //   closeOnPopstate: true,//页面回退时自动关闭
        //   title: '网络不畅，详情拉取失败',
        //   message: '您可以尝试：',
        //   confirmButtonText: '刷新重试',
        //   cancelButtonText: window.history.length > 1 ? '返回上一页' : '前往首页'
        // }).then(() => {
        //   location.reload(true);
        // }).catch(() => {
        //   window.history.length > 1 ? history.back() : _this.$router.replace({ path: '/'});
        // });


      });

    },
    //载入相关图纸 结束 ==========================
    //折叠相关视频并滚动到合适的位置
    foldAndScrollInstruction(){
      const _this = this;
      if( _this.setInstructionFolded ){
        _this.setInstructionFolded = false;
      } else {
        _this.setInstructionFolded = true;

        let headerHeight = document.querySelector('.common_header').offsetHeight + document.querySelector('.tab_nav').offsetHeight;
        let targetTop = document.querySelector("#setindex_main").offsetTop + document.querySelector("#setindex_instruction").offsetTop - headerHeight;
        //_this.scrollToTop(300, targetTop);

        _this.scrollToTop(300, targetTop);
      }
    },

    //载入相关视频 开始 ==========================
    getSetVideo(callback){
      const _this = this;

      let tmpParams = {
        ///setid: _this.setId,
        //user_id: _this.$store.state.loginUser.sessionkey,
      };
      
      if( _this.setnumberId > 0 ){//传参为套组ID
        tmpParams.setnumberid = _this.setnumberId;
      } else if( _this.setBrand && _this.setNumber ) {//传参为品牌+编号
        tmpParams.setbrand = _this.setBrand;
        tmpParams.setnumber = _this.setNumber;
      } else {//缺少关键传参
        //
      }

      _this.axios.post(_this.$store.state.api.common + 'set/video/', _this.qs.stringify(tmpParams)).then(function(res){
        if( res.status == 200 ){
          if( typeof res.data != "object" ){
            try{
              res.data = JSON.parse(res.data);
            } catch(error) {
              // _this.$dialog.confirm({
              //   closeOnPopstate: true,//页面回退时自动关闭
              //   title: '载入套组详情失败',
              //   message: '您可以尝试：',
              //   confirmButtonText: '刷新重试',
              //   cancelButtonText: window.history.length > 1 ? '返回上一页' : '前往首页'
              // }).then(() => {
              //   location.reload(true);
              // }).catch(() => {
              //   window.history.length > 1 ? history.back() : _this.$router.replace({ path: '/'});
              // });
              console.error(error);
              return false;
            }
          }
          if( res.data.status == 1 ){

            _this.setVideo = res.data.data;

            //console.log(_this.setVideo);
            callback && callback();

          }else{
            // _this.$dialog.confirm({
            //   closeOnPopstate: true,//页面回退时自动关闭
            //   title: res.data.msg ? res.data.msg : '载入套组详情，出现了一些问题',
            //   message: '您可以尝试：',
            //   confirmButtonText: '刷新重试',
            //   cancelButtonText: window.history.length > 1 ? '返回上一页' : '前往首页'
            // }).then(() => {
            //   location.reload(true);
            // }).catch(() => {
            //   window.history.length > 1 ? history.back() : _this.$router.replace({ path: '/'});
            // });
          }
        }else{
          // _this.$dialog.confirm({
          //   closeOnPopstate: true,//页面回退时自动关闭
          //   title: '套组详情拉取失败',
          //   message: '您可以尝试：',
          //   confirmButtonText: '刷新重试',
          //   cancelButtonText: window.history.length > 1 ? '返回上一页' : '前往首页'
          // }).then(() => {
          //   location.reload(true);
          // }).catch(() => {
          //   window.history.length > 1 ? history.back() : _this.$router.replace({ path: '/'});
          // });
        }
      }).catch(function (error) {
        console.error(error);

        // _this.$dialog.confirm({
        //   closeOnPopstate: true,//页面回退时自动关闭
        //   title: '网络不畅，详情拉取失败',
        //   message: '您可以尝试：',
        //   confirmButtonText: '刷新重试',
        //   cancelButtonText: window.history.length > 1 ? '返回上一页' : '前往首页'
        // }).then(() => {
        //   location.reload(true);
        // }).catch(() => {
        //   window.history.length > 1 ? history.back() : _this.$router.replace({ path: '/'});
        // });


      });

    },
    //载入相关视频 结束 ==========================


    //载入相关文章 开始 ==========================
    getSetArticle(callback){
      const _this = this;

      let tmpParams = {
        ///setid: _this.setId,
        //user_id: _this.$store.state.loginUser.sessionkey,
        is_wxapp: (_this.$store.state.browser.wxminiprogram || _this.$store.state.browser.bdminiprogram) ? 1 : 0,
        //is_mobile: _this.$store.state.browser.m && !_this.$store.state.browser.ipad6 ? 1 : 0,
      };
      
      if( _this.setnumberId > 0 ){//传参为套组ID
        tmpParams.setnumberid = _this.setnumberId;
      } else if( _this.setBrand && _this.setNumber ) {//传参为品牌+编号
        tmpParams.setbrand = _this.setBrand;
        tmpParams.setnumber = _this.setNumber;
      } else {//缺少关键传参
        //
      }

      _this.axios.post(_this.$store.state.api.common + 'set/article/', _this.qs.stringify(tmpParams)).then(function(res){
        if( res.status == 200 ){
          if( typeof res.data != "object" ){
            try{
              res.data = JSON.parse(res.data);
            } catch(error) {
              // _this.$dialog.confirm({
              //   closeOnPopstate: true,//页面回退时自动关闭
              //   title: '载入套组详情失败',
              //   message: '您可以尝试：',
              //   confirmButtonText: '刷新重试',
              //   cancelButtonText: window.history.length > 1 ? '返回上一页' : '前往首页'
              // }).then(() => {
              //   location.reload(true);
              // }).catch(() => {
              //   window.history.length > 1 ? history.back() : _this.$router.replace({ path: '/'});
              // });
              console.error(error);
              return false;
            }
          }
          if( res.data.status == 1 ){

            _this.setVideo = [];

            _this.setArticle = res.data.data;

            _this.setArticle2 = [];

            res.data.data.forEach(function(article_n){

              let tmpArticle = {
                cover: article_n.cover,
                //from: article_n.from,
                tag: article_n.tag,
                text: article_n.text,
                title: article_n.title,
                type: article_n.type,
                url: article_n.url,
              }

              //先提取出B站视频
              if( /bilibili.com\/video/i.test(article_n.url) ){

                // let tmpBV = article_n.url.match("BV[0-9a-zA-Z]+")[0];
                // if( tmpBV.length ){
                //   article_n.bvid = tmpBV;
                //   _this.setVideo.push(article_n);
                //   return;
                // }
                if( article_n.bilibili_aid && article_n.bilibili_bvid ){
                  _this.setVideo.push(article_n);
                  return;
                }
                
              }

              let tmpAuthorExist = 0;
              _this.setArticle2.forEach(function(author_n){
                if( article_n.author && author_n.author == article_n.author ){
                  //author_n.article.push(tmpArticle);

                  author_n.more = author_n.more + 1;

                  let tmpArticleExist = 0;
                  author_n.article.forEach(function(n){
                    if( n.from == article_n.from ){
                      n.list.push(tmpArticle);
                      tmpArticleExist = 1;
                    }
                  });
                  if( !tmpArticleExist ){
                    author_n.article.push({
                      from: article_n.from,
                      list: [tmpArticle]
                    });
                  }
                  tmpAuthorExist = 1;
                }
              });
              if( !tmpAuthorExist ){
                _this.setArticle2.push({

                  more: 0,

                  cover: article_n.cover,
                  from: article_n.from,
                  tag: article_n.tag,
                  text: article_n.text,
                  title: article_n.title,
                  type: article_n.type,
                  url: article_n.url,

                  avatar: article_n.avatar,
                  author: article_n.author,
                  article: [{
                    from: article_n.from,
                    list: [tmpArticle]
                  }]
                });
              }

            });


            //console.log(_this.setArticle2);
            //console.log(_this.setArticle);
            callback && callback();

          }else{
            // _this.$dialog.confirm({
            //   closeOnPopstate: true,//页面回退时自动关闭
            //   title: res.data.msg ? res.data.msg : '载入套组详情，出现了一些问题',
            //   message: '您可以尝试：',
            //   confirmButtonText: '刷新重试',
            //   cancelButtonText: window.history.length > 1 ? '返回上一页' : '前往首页'
            // }).then(() => {
            //   location.reload(true);
            // }).catch(() => {
            //   window.history.length > 1 ? history.back() : _this.$router.replace({ path: '/'});
            // });
          }
        }else{
          // _this.$dialog.confirm({
          //   closeOnPopstate: true,//页面回退时自动关闭
          //   title: '套组详情拉取失败',
          //   message: '您可以尝试：',
          //   confirmButtonText: '刷新重试',
          //   cancelButtonText: window.history.length > 1 ? '返回上一页' : '前往首页'
          // }).then(() => {
          //   location.reload(true);
          // }).catch(() => {
          //   window.history.length > 1 ? history.back() : _this.$router.replace({ path: '/'});
          // });
        }
      }).catch(function (error) {
        console.error(error);

        // _this.$dialog.confirm({
        //   closeOnPopstate: true,//页面回退时自动关闭
        //   title: '网络不畅，详情拉取失败',
        //   message: '您可以尝试：',
        //   confirmButtonText: '刷新重试',
        //   cancelButtonText: window.history.length > 1 ? '返回上一页' : '前往首页'
        // }).then(() => {
        //   location.reload(true);
        // }).catch(() => {
        //   window.history.length > 1 ? history.back() : _this.$router.replace({ path: '/'});
        // });


      });

    },
    //载入相关文章 结束 ==========================
    //折叠相关文章并滚动到合适的位置
    foldAndScrollArticle(){
      const _this = this;
      if( _this.setArticleFolded ){
        _this.setArticleFolded = false;
      } else {
        _this.setArticleFolded = true;

        let headerHeight = document.querySelector('.common_header').offsetHeight + document.querySelector('.tab_nav').offsetHeight;
        let targetTop = document.querySelector("#setindex_main").offsetTop + document.querySelector("#setindex_article").offsetTop - headerHeight;
        //_this.scrollToTop(300, targetTop);

        _this.scrollToTop(300, targetTop);
      }
    },


    //载入相关购物入口 开始 ==========================
    getSetShopping(callback){
      const _this = this;

      let tmpParams = {
        ///setid: _this.setId,
        //user_id: _this.$store.state.loginUser.sessionkey,
      };
      
      if( _this.setnumberId > 0 ){//传参为套组ID
        tmpParams.setnumberid = _this.setnumberId;
      } else if( _this.setBrand && _this.setNumber ) {//传参为品牌+编号
        tmpParams.setbrand = _this.setBrand;
        tmpParams.setnumber = _this.setNumber;
      } else {//缺少关键传参
        //
      }

      _this.axios.post(_this.$store.state.api.common + 'set/shopping/', _this.qs.stringify(tmpParams)).then(function(res){
        if( res.status == 200 ){
          if( typeof res.data != "object" ){
            try{
              res.data = JSON.parse(res.data);
            } catch(error) {
              // _this.$dialog.confirm({
              //   closeOnPopstate: true,//页面回退时自动关闭
              //   title: '载入套组详情失败',
              //   message: '您可以尝试：',
              //   confirmButtonText: '刷新重试',
              //   cancelButtonText: window.history.length > 1 ? '返回上一页' : '前往首页'
              // }).then(() => {
              //   location.reload(true);
              // }).catch(() => {
              //   window.history.length > 1 ? history.back() : _this.$router.replace({ path: '/'});
              // });
              console.error(error);
              return false;
            }
          }
          if( res.data.status == 1 ){

            let fatch_data = res.data.data;

            _this.setShopping = [];

            fatch_data.forEach(function(shopping_n){

              if( shopping_n.logo ){
                shopping_n.logo = _this.$store.state.api.img + shopping_n.logo + '!brand_s';
              }
              if( shopping_n.site == shopping_n.title ){
                shopping_n.title = "";
              }

              //取得最低价格
              let tmp_price = parseFloat(shopping_n.price.replace("¥", ""));
              if( !isNaN(tmp_price) && (_this.setPriceLower == 0 || tmp_price < _this.setPriceLower) ){
                _this.setPriceLower = tmp_price;
              }

              _this.setShopping.push(shopping_n);

            });

            //console.log(_this.setShopping);
            callback && callback(res.data.timeflow);

          }else{
            // _this.$dialog.confirm({
            //   closeOnPopstate: true,//页面回退时自动关闭
            //   title: res.data.msg ? res.data.msg : '载入套组详情，出现了一些问题',
            //   message: '您可以尝试：',
            //   confirmButtonText: '刷新重试',
            //   cancelButtonText: window.history.length > 1 ? '返回上一页' : '前往首页'
            // }).then(() => {
            //   location.reload(true);
            // }).catch(() => {
            //   window.history.length > 1 ? history.back() : _this.$router.replace({ path: '/'});
            // });
          }
        }else{
          // _this.$dialog.confirm({
          //   closeOnPopstate: true,//页面回退时自动关闭
          //   title: '套组详情拉取失败',
          //   message: '您可以尝试：',
          //   confirmButtonText: '刷新重试',
          //   cancelButtonText: window.history.length > 1 ? '返回上一页' : '前往首页'
          // }).then(() => {
          //   location.reload(true);
          // }).catch(() => {
          //   window.history.length > 1 ? history.back() : _this.$router.replace({ path: '/'});
          // });
        }
      }).catch(function (error) {
        console.error(error);

        // _this.$dialog.confirm({
        //   closeOnPopstate: true,//页面回退时自动关闭
        //   title: '网络不畅，详情拉取失败',
        //   message: '您可以尝试：',
        //   confirmButtonText: '刷新重试',
        //   cancelButtonText: window.history.length > 1 ? '返回上一页' : '前往首页'
        // }).then(() => {
        //   location.reload(true);
        // }).catch(() => {
        //   window.history.length > 1 ? history.back() : _this.$router.replace({ path: '/'});
        // });


      });

    },
    //载入相关购物入口 结束 ==========================

    //载入关联套组 开始 ==========================
    getSetRelset(callback){
      const _this = this;

      let tmpParams = {
        ///setid: _this.setId,
        //user_id: _this.$store.state.loginUser.sessionkey,
      };
      
      if( _this.setnumberId > 0 ){//传参为套组ID
        tmpParams.setnumberid = _this.setnumberId;
      } else if( _this.setBrand && _this.setNumber ) {//传参为品牌+编号
        tmpParams.setbrand = _this.setBrand;
        tmpParams.setnumber = _this.setNumber;
      } else {//缺少关键传参
        //
      }

      _this.axios.post(_this.$store.state.api.common + 'set/relset/', _this.qs.stringify(tmpParams)).then(function(res){
        if( res.status == 200 ){
          if( typeof res.data != "object" ){
            try{
              res.data = JSON.parse(res.data);
            } catch(error) {
              // _this.$dialog.confirm({
              //   closeOnPopstate: true,//页面回退时自动关闭
              //   title: '载入套组详情失败',
              //   message: '您可以尝试：',
              //   confirmButtonText: '刷新重试',
              //   cancelButtonText: window.history.length > 1 ? '返回上一页' : '前往首页'
              // }).then(() => {
              //   location.reload(true);
              // }).catch(() => {
              //   window.history.length > 1 ? history.back() : _this.$router.replace({ path: '/'});
              // });
              console.error(error);
              return false;
            }
          }
          if( res.data.status == 1 ){

            //_this.setRelset = res.data.data;

            let fatch_data = res.data.data;

            _this.setRelset = [];

            fatch_data.forEach(function(relset_n){

              if( relset_n.cover ){
                relset_n.cover = _this.$store.state.api.img + relset_n.cover + '!setlist.webp';
              }

              if( relset_n.brandlogo ){
                relset_n.brandlogo = _this.$store.state.api.img + relset_n.brandlogo + '!brand_s';
              }

              _this.setRelset.push(relset_n);

            });

            //console.log(_this.setRelset);
            callback && callback();

          }else{
            // _this.$dialog.confirm({
            //   closeOnPopstate: true,//页面回退时自动关闭
            //   title: res.data.msg ? res.data.msg : '载入套组详情，出现了一些问题',
            //   message: '您可以尝试：',
            //   confirmButtonText: '刷新重试',
            //   cancelButtonText: window.history.length > 1 ? '返回上一页' : '前往首页'
            // }).then(() => {
            //   location.reload(true);
            // }).catch(() => {
            //   window.history.length > 1 ? history.back() : _this.$router.replace({ path: '/'});
            // });
          }
        }else{
          // _this.$dialog.confirm({
          //   closeOnPopstate: true,//页面回退时自动关闭
          //   title: '套组详情拉取失败',
          //   message: '您可以尝试：',
          //   confirmButtonText: '刷新重试',
          //   cancelButtonText: window.history.length > 1 ? '返回上一页' : '前往首页'
          // }).then(() => {
          //   location.reload(true);
          // }).catch(() => {
          //   window.history.length > 1 ? history.back() : _this.$router.replace({ path: '/'});
          // });
        }
      }).catch(function (error) {
        console.error(error);

        // _this.$dialog.confirm({
        //   closeOnPopstate: true,//页面回退时自动关闭
        //   title: '网络不畅，详情拉取失败',
        //   message: '您可以尝试：',
        //   confirmButtonText: '刷新重试',
        //   cancelButtonText: window.history.length > 1 ? '返回上一页' : '前往首页'
        // }).then(() => {
        //   location.reload(true);
        // }).catch(() => {
        //   window.history.length > 1 ? history.back() : _this.$router.replace({ path: '/'});
        // });


      });

    },
    //载入关联套组 结束 ==========================
    
    //载入其他推荐套组 开始 ==========================
    getSetRecommendset(callback){
      const _this = this;

      let tmpParams = {
        ///setid: _this.setId,
        //user_id: _this.$store.state.loginUser.sessionkey,
      };
      
      if( _this.setnumberId > 0 ){//传参为套组ID
        tmpParams.setnumberid = _this.setnumberId;
      } else if( _this.setBrand && _this.setNumber ) {//传参为品牌+编号
        tmpParams.setbrand = _this.setBrand;
        tmpParams.setnumber = _this.setNumber;
      } else {//缺少关键传参
        //
      }

      _this.axios.post(_this.$store.state.api.common + 'set/recommendset/', _this.qs.stringify(tmpParams)).then(function(res){
        if( res.status == 200 ){
          if( typeof res.data != "object" ){
            try{
              res.data = JSON.parse(res.data);
            } catch(error) {
              // _this.$dialog.confirm({
              //   closeOnPopstate: true,//页面回退时自动关闭
              //   title: '载入套组详情失败',
              //   message: '您可以尝试：',
              //   confirmButtonText: '刷新重试',
              //   cancelButtonText: window.history.length > 1 ? '返回上一页' : '前往首页'
              // }).then(() => {
              //   location.reload(true);
              // }).catch(() => {
              //   window.history.length > 1 ? history.back() : _this.$router.replace({ path: '/'});
              // });
              console.error(error);
              return false;
            }
          }
          if( res.data.status == 1 ){

            _this.setRecommendsetGetOver = 1;//载入成功

            let fatch_data = res.data.data;

            _this.setRecommendset = [];

            fatch_data.forEach(function(relset_n){

              if( relset_n.cover ){
                relset_n.cover = _this.$store.state.api.img + relset_n.cover + '!setlist.webp';
              }

              if( relset_n.brandlogo ){
                relset_n.brandlogo = _this.$store.state.api.img + relset_n.brandlogo + '!brand_s';
              }

              _this.setRecommendset.push(relset_n);

            });

            //console.log(_this.setRecommendset);
            callback && callback();

          }else{

            _this.setRecommendsetGetOver = 2;//载入失败

            // _this.$dialog.confirm({
            //   closeOnPopstate: true,//页面回退时自动关闭
            //   title: res.data.msg ? res.data.msg : '载入套组详情，出现了一些问题',
            //   message: '您可以尝试：',
            //   confirmButtonText: '刷新重试',
            //   cancelButtonText: window.history.length > 1 ? '返回上一页' : '前往首页'
            // }).then(() => {
            //   location.reload(true);
            // }).catch(() => {
            //   window.history.length > 1 ? history.back() : _this.$router.replace({ path: '/'});
            // });
          }
        }else{

          _this.setRecommendsetGetOver = 2;//载入失败

          // _this.$dialog.confirm({
          //   closeOnPopstate: true,//页面回退时自动关闭
          //   title: '套组详情拉取失败',
          //   message: '您可以尝试：',
          //   confirmButtonText: '刷新重试',
          //   cancelButtonText: window.history.length > 1 ? '返回上一页' : '前往首页'
          // }).then(() => {
          //   location.reload(true);
          // }).catch(() => {
          //   window.history.length > 1 ? history.back() : _this.$router.replace({ path: '/'});
          // });
        }
      }).catch(function (error) {
        console.error(error);

        _this.setRecommendsetGetOver = 2;//载入失败

        // _this.$dialog.confirm({
        //   closeOnPopstate: true,//页面回退时自动关闭
        //   title: '网络不畅，详情拉取失败',
        //   message: '您可以尝试：',
        //   confirmButtonText: '刷新重试',
        //   cancelButtonText: window.history.length > 1 ? '返回上一页' : '前往首页'
        // }).then(() => {
        //   location.reload(true);
        // }).catch(() => {
        //   window.history.length > 1 ? history.back() : _this.$router.replace({ path: '/'});
        // });


      });

    },
    //载入其他推荐套组 结束 ==========================



    //相册面板查看大图
    albumPreview(index){
      const _this = this;
      ImagePreview({
        images: _this.setDetail.cover_arr,
        startPosition: index,
        closeOnPopstate: true,
      });
    },

    //预览视频
    previewVideo(index){
      const _this = this;

      let tmpParams = {
        url: _this.setVideo[index].url,
      };
      _this.axios.post(_this.$store.state.api.common + 'goto/link/', _this.qs.stringify(tmpParams)).then(function(res){
      }).catch(function (error) {
        console.error(error);
      });

      if( _this.$store.state.browser.wxminiprogram ){
        //wx.miniProgram.navigateTo({url: '/pages/goto_bilibili/index?url=' + encodeURIComponent(url)})
        wx.miniProgram.navigateTo({url: '/pages/goto_bilibili/index?aid=' + _this.setVideo[index].bilibili_aid});
      }else if( _this.$store.state.browser.bdminiprogram ){

        const timestamp = new Date().getTime()
        let path = `pages/video/video?__preload_=${timestamp*10+3}&__key_=${timestamp*10+4}&avid=${_this.setVideo[index].bilibili_aid}`

        swan.navigateToSmartProgram({
            // 打开目标小程序的AppKey，开发版AppKey可在开发者工具中预览获取
            appKey: 'pKACmZ92p00QB5DYMttIugOmmI1XQBhG',
            // 打开的页面路径，如果为空则打开首页
            path: path,
            extraData: {
                foo: 'baidu'
            },
            success: res => {
                console.log('navigateToSmartProgram success', res);
            },
            fail: err => {
                console.log('navigateToSmartProgram fail', err);
            }
        });

      } else {
        _this.showSubplateVideo = true;
        _this.urlVideo = "https://player.bilibili.com/player.html?bvid=" + _this.setVideo[index].bilibili_bvid;
      }

    },





    //切换价格曲线 开始 ==========================
    changePriceflow(index){
      const _this = this;

      let thisItem = _this.setShopping[index];

      _this.timeflow_option.series[3].name = (thisItem.site ? "【"+thisItem.site+"】" : "") + thisItem.title;
      _this.timeflow_option.series[3].data = thisItem.timeflow;

      _this.timeflow_option.series[3].markPoint = {
        symbol: 'pin',
        data: [
          {
            name: '最低',
            type: 'min',
            label: {
              show: false,
            },
            symbolSize: 20,
            symbolRotate: 180,
          },
          {
            name: '最高',
            type: 'max',
            label: {
              show: false,
            },
            symbolSize: 20,
          },
          // {
          //   name: '最近价格',
          //   //yAxis: 10,
          //   x: '100%'
          // }
        ],
      };

      //保留前4组，删除其他参考价格（避免重复插入）
      _this.timeflow_option.series.splice(4, _this.timeflow_option.series.length - 4);

      //突出标注最近一条价格
      _this.timeflow_option.series.push({

        symbol: 'circle',
        symbolSize: 8,
        type: 'scatter',
        smooth: false,
        name: '',
        itemStyle: {
          color: '#ef3a3a',
          opacity: 1,
        },
        lineStyle: {
          width: 0,
        },
        emphasis: {
          itemStyle: {
            borderWidth: 0,
          },
        },
        silent: false,
        data: [thisItem.timeflow[thisItem.timeflow.length-1]]

      });

      //插入同期其他价格作为参考
      _this.setShopping.forEach(function(n, i){
        if( i != index ){
          _this.timeflow_option.series.push({

            symbol: 'circle',
            symbolSize: 2,
            type: 'scatter',
            smooth: false,
            name: '',
            itemStyle: {
              color: '#ef3a3a',
              opacity: .5,
            },
            lineStyle: {
              width: 0,
            },
            silent: false,
            data: [_this.setShopping[i].timeflow[_this.setShopping[i].timeflow.length-1]]

          });
        }
      });

      //console.log(_this.timeflow_option);


      _this.price_timeflow_ech.setOption(_this.timeflow_option);
    },
    //切换价格曲线 结束 ==========================





    //============= 开始 ==========================





    //============= 结束 ==========================



    //============= 其他 结束 ==========================



  },
  beforeRouteEnter(to, from, next) {//进入
    const _this = this;
    // alert("from2:" + from.fullPath);
    // alert("to2:" + to.fullPath);
    next();
  },
  beforeRouteLeave (to, from, next) {//离开
    const _this = this;
    // alert("from3:" + from.fullPath);
    // alert("to3:" + to.fullPath);

    clearInterval(_this.timeoutMapBaidu);

    next();
  },
}
</script>


<style lang="less">

</style>
<style lang="less" scoped>
.price_timeflow_echarts {
  height: 150px;
  margin-bottom: 20px;
}



.common_header {
  box-shadow: none;
}

.common_header.header_transparent {
  box-shadow: none;
  background-color: transparent!important;
  background-image: initial!important;
  color: #666;
}

.goodsview_header_box.common_header.header_transparent .header_leftarea .btn:before {
  content: "";
  display: block;
  width: 40px;
  height: 40px;
  background-color: #fff;
  border-radius: 100px;
  position: absolute;
  left: 5px;
  top: 5px;
  /*box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);*/
}
.goodsview_header_box.common_header.header_transparent .header_title {
  color: transparent;
}


.tab_nav {
  background-color: #fff;
  box-shadow: 0 1px 10px rgba(0,0,0,.15);
  opacity: 1;
  transition: .3s;
  a:hover {
    color: #e62828;
  }
  a.active {
    color: #e62828;
    border-bottom: 3px solid #e62828;
  }
  &.hide {
    opacity: 0;
  }
}




/** 第一屏 套组详情页 **/
#setindex_maintop {
  margin-top: -50px;
  #setindex_maintop_box {
    padding: 0 30px 140px;
    .setindex_bigcover_wrap {
      position: relative;
      margin-left: -30px;
      margin-right: -30px;
      margin-bottom: 20px;
      /*&:after {
        content: "";
        display: block;
        position: absolute;
        width: 100%;
        height: 40px;
        background-image: linear-gradient(rgba(255, 255, 255, 0), #fff);
        bottom: 0;
      }*/
    }
    .setindex_bigcover_swipe {
      .image {
        padding-top: 80%;
        width: 100%;
        background-size: contain;
      }
      .custom-indicator {
        position: absolute;
        right: 5px;
        bottom: 5px;
        padding: 2px 10px;
        font-size: 12px;
        background: rgba(0, 0, 0, 0.8);
        color: #fff;
        border-radius: 100px;
      }
      .btn_album {
        background-color: white;
        position: absolute;
        bottom: 25px;
        right: 5px;
        width: 40px;
        line-height: 40px;
        opacity: .5;
        transition: all .3s;
        &:hover {
          opacity: 1;
        }
      }
    }
    .setindex_bigcover {
      padding-top: 80%;
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
    }
    .brandandnumber {
      align-items: center;
      display: flex;
      font-size: 20px;
      line-height: 1;
      .logo {
        display: inline-block;
        width: 30px;
        height: 30px;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;
        flex-shrink: 0;
        margin-right: 5px;
        border-radius: 4px;
        /*box-shadow: inset 0 0 5px rgba(0,0,0,.1);*/
      }
      .brand {
        /*flex: 1;*/
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        padding-right: 5px;
        overflow: hidden;
        &.skeleton_brand {
          width: 100px;
          height: 20px;
          background-color: #f4f4f4;
          background-image: linear-gradient(to right, #f4f4f4 18%, #fcfcfc);
        }
      }
      .number {
        flex-shrink: 0;
        white-space: nowrap;
        font-weight: bold;
      }
    }
    .title {
      font-size: 30px;
      font-weight: bold;
      min-height: 40px;
      &.skeleton_title {
        position: relative;
        &:before {
          content: "";
          position: absolute;
          top: 5px;
          bottom: 5px;
          width: 100%;
          background-color: #f4f4f4;
          background-image: linear-gradient(to right, #e8e8e8 18%, #fcfcfc);
        }
      }
      .model_scale {
        background-color: #333;
        color: #fff;
        padding: 2px 5px;
        font-size: 15px;
        vertical-align: middle;
        margin-left: 5px;
        border-radius: 3px;
      }
    }
    .subtitle {
      font-size: 20px;
      font-weight: bold;
      color: #e62828;
      min-height: 26px;
      &.skeleton_subtitle {
        width: 70%;
        height: 26px;
        min-height: unset;
        background-color: #f4f4f4;
        background-image: linear-gradient(to right, #f4f4f4 18%, #fcfcfc);
      }
    }

    /** 主参数 **/
    .setindex_param {
      display: flex;
      flex-flow: row;
      text-align: center;
      .item_param {
        flex: 1;
        padding-top: 10px;
        padding-bottom: 10px;
        .num {
          font-size: 18px;
          font-weight: bold;
        }
      }
    }
    /** 新品标签 **/
    .sign {
      background-color: #ffcf00;
      color: #333;
      display: inline-block;
      padding: 0 10px;
      border-radius: 100px;
      margin: 5px auto 0;
      line-height: 24px;
      &.sign_newrelease {
        background-color: #fff;
        color: #ef3a3a;
        box-shadow: inset 0 0 0 1px #ef3a3a;
      }
      &.sign_newadd {
        background-color: #fff;
        color: #42bf53;
        box-shadow: inset 0 0 0 1px #42bf53;
      }
      &.sign_outofprint {
        background-color: #f4f4f4;
        color: #999;
        box-shadow: inset 0 0 0 1px #999;
      }
      &.sign_outofprintsoon {
        background-color: #333;
        color: #ffcf00;
      }
    }
    /** 零件类型 **/
    .bricktype {
      color: #fff;
      background-color: #ffa317;
      display: inline-block;
      padding: 0 10px;
      border-radius: 100px;
      margin: 5px auto 0;
      cursor: pointer;
      line-height: 24px;
      * {
        vertical-align: top;
        display: inline-block;
        line-height: inherit;
      }
      .material-icons {
        transform: scale(.6);
        margin-right: -5px;
      }
      &.color_2 {
        background-color: #42bf53;
      }
      &.color_3 {
        background-color: #e4b61c;
      }
      &.color_4 {
        background-color: #2b76c6;
      }
    }

    /** 详细参数 **/
    .table_param_wrap{
      background-color: #f4f4f4;
      background-image: linear-gradient(#fff3f3 20%, #f4f4f4 90%);
      border-radius: 10px;
      .table_param {
        padding: 30px;
        dl {
          display: flex;
          padding: 5px 0;
          margin: 0;
          dt {
            flex-shrink: 0;
            padding: 0 0 0 10px;
            margin: 0;
            width: 100px;
            opacity: .6;
          }
          dd {
            flex: 1;
            padding: 0 10px 0 0;
            margin: 0;
            overflow: hidden;
          }
          &:nth-child(even) {
            background-color: rgba(255,255,255,.5);
          }
        }
      }
      .btn_more {
        color: #e62828;
        display: block;
        text-align: right;
        padding: 0 10px;
        line-height: 30px;
      }
    }
    .tr_param_ean /deep/ .vue-barcode-element {
      /*max-width: 100%;*/
    }

    /** 头部购买 **/
    .form_item {
      margin-top: 10px;
      transition: all 0.3s;
      height: 42px;
      .price {
        color: #e62828;
        font-size: 20px;
        text-align: left;
        font-weight: bold;
        &.disabled {
          font-size: 12px;
          color: #d6d6d6;
        }
        .ppp {
          font-size: 12px;
          color: #999;
          font-weight: normal;
          transform: scale(.9);
          transform-origin: left;
        }
      }
      &.hashide {
        height: 0;
        opacity: 0;
        overflow: hidden;
      }
    }



  }
}


/** 主体 套组详情页 **/
#setindex_main {
  padding: 0 0 20px;
  background-color: #fff;
  margin-top: -120px;/*30px*//*50px*/
  margin-bottom: 0;
  z-index: 10;
  position: relative;
  border-radius: 20px 20px 0 0;
  box-shadow: 0 0 20px rgba(0,0,0,.1);
  overflow: hidden;
  /*animation: setindex_main_ani 1s ease-out;*/
  @keyframes setindex_main_ani {
    0%   {transform: translateY(-300px);}
    100% {transform: translateY(0);}
  }
  .main_title {
    padding: 0;
    .title {
      font-size: 18px;
      font-weight: bold;
    }
  }
  .maincard_hasborder {
    border-bottom: solid 10px #f4f4f4;
  }
  .main_tips {
    opacity: .5;
    margin: 0 30px 20px;
  }
}



.folded .card_more {
  position: absolute;
  z-index: 1;
  bottom: 0;
  left: 0;
  width: 100%;
  display: block;
  line-height: 40px;
  text-align: center;
  cursor: pointer;
  color: #e62828;
  font-size: 12px;
  &:before {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 150px;
    display: block;
    line-height: 50px;
    text-align: center;
    cursor: pointer;
    color: #999;
    font-weight: bold;
    background-image: linear-gradient(rgba(255, 255, 255, 0), #fff 70%);
  }
  span {
    width: 100%;
    display: block;
    line-height: 40px;
    position: absolute;
    bottom: 0;
    left: 0;
  }
}



/** 描述 套组详情页 **/
#setindex_describe {
  padding: 10px 30px 20px;
  .theme_text {
    margin-top: 20px;
    margin-bottom: 10px;
    * {
      line-height: 20px;
      vertical-align: top;
      display: inline-block;
      height: 20px;
    }
    a {
      font-size: 0;
      span {
        font-size: 12px;
      }
      &:after {
        font-family: 'Material Icons';
        font-size: 18px;
        content: "";
        color: #ccc;
      }
      &:last-child {
        font-weight: bold;
        &:after {
          display: none;
        }
        span {
          font-size: 14px;
        }
      }
    }
  }

  

  .list_pic {
    .item_pic {
      img {
        width: 100%;
      }
    }
  }





  .original_badge {
    line-height: 22px;
    margin-bottom: 10px;
    background-color: #f4f4f4;
    padding: 10px 15px;
    display: inline-block;
    border-radius: 5px;
    .logo {
      display: inline-block;
      width: 25px;
      height: 25px;
      margin-right: 5px;
      background-position: center;
      background-repeat: no-repeat;
      background-size: contain;
      border-radius: 1px;
      vertical-align: bottom;
    }
    span {
      display: inline-block;
      vertical-align: bottom;
      color: #333;
      opacity: .5;
    }
    &.original_badge_legoideas {
      .logo {
        width: 47px;
      }
    }
  }


}
/*
#setindex_describe #map_container {
  height: 200px;
  border-radius: 10px;
  margin-bottom: 5px;
}
*/
#setindex_describe #map_staticimage {
  overflow: hidden;
  border-radius: 10px;
  margin-bottom: 5px;
  position: relative;
  img {
    width: 100%;
  }
  &:after {
    content: "";
    display: block;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    border-radius: inherit;
    box-shadow: inset 0 0 0 2px #333, inset 0 0 30px #000;
    opacity: .1;
  }
  .landmark_title {
    position: absolute;
    z-index: 1;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -40px);
    background-color: #333;
    color: #fff;
    padding: 5px 10px;
    border-radius: 4px;
    box-shadow: 0 -4px 0 0 #e62828;
    font-weight: bold;
  }
  .landmark_pin {
    &:before {
      content: "";
      display: block;
      background-color: #000;
      width: 20px;
      height: 10px;
      position: absolute;
      border-radius: 100px;
      right: 50%;
      bottom: 50%;
      margin: auto -10px -5px auto;
      filter: blur(5px);
      opacity: .8;
    }
    &:after {
      content: "";
      display: block;
      background-color: #222;/* #e62828 */
      width: 30px;
      height: 30px;
      position: absolute;
      border-radius: 100px 100px 0;
      right: 50%;
      bottom: 50%;
      transform: rotate(45deg);
      transform-origin: 100% 100%;
      box-shadow: -3px -3px 0 0 #e62828;
      /*box-shadow: -2px -2px 0 0 #ff5f5f, inset 2px 2px 0 0 #ff6464, inset 3px 3px 0 0 #ff7b5d, inset 5px 5px 10px #c31414, inset -5px -5px 10px #c31414;*/
    }
  }
}


#setindex_describe .richtext_wrap {
  position: relative;
  .set_text {
    /*white-space: pre-wrap;*/
    font-size: 14px;
    line-height: 1.7;
    /deep/img {
      min-height: 200px;
    }
    /deep/video {
      width: 100%;
      border-radius: 10px;
      background-color: #000;
    }
  }
  &.folded {
    height: 350px;
    overflow: hidden;
  }
  .card_more {
    /*position: absolute;
    z-index: 1;
    bottom: 0;
    left: 0;
    width: 100%;
    display: none;*/
    color: #e62828;
    background-color: transparent;
  }
  &.folded .card_more {
    display: block;
  }
}



/** 人仔 套组详情页 **/
#setindex_minifigs {
  padding: 10px 0 10px;
  .main_title {
    padding-left: 30px;
    padding-right: 30px;
  }
  .list_setindex_minifigs_wrap {
    padding: 0 30px 10px;
    overflow: auto;
    .list_setindex_minifigs {
      white-space: nowrap;
      /*display: flex;*/
      font-size: 0;
      .item_setindex_minifigs {
        font-size: 12px;
        display: inline-block;
        width: 100px;
        vertical-align: top;
        text-align: center;
        position: relative;
        margin: 0 5px 0 0;
        padding: 0 10px 5px;
        /*border-right: 1px solid #eee;*/
        .img {
          height: 110px;
          position: relative;
          img {
            max-width: 60px;
            max-height: 100%;
            position: absolute;
            bottom: 0;
            left: 50%;
            transform: translate(-50%, 0);
          }
        }
        .name {
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          white-space: initial;
        }
        .code {
          opacity: .5;
          line-height: 24px;
          font-weight: bold;
          text-transform: uppercase;
        }
        .sign {
          position: absolute;
          top: 0;
          left: 0;
          background-color: #f3c546;
          padding: 2px 5px;
          border-radius: 3px;
          transform: scale(.8);
          transform-origin: 0;
          /*margin-top: 5px;*/
        }
      }
      .doufu {
        display: inline-block;
        height: 10px;
        width: 40px;
      }
    }
  }
}



/** 设计师 套组详情页 **/
#setindex_designer {
  padding: 10px 0 10px;
  .main_title {
    padding-left: 30px;
    padding-right: 30px;
  }
  .list_setindex_designer_wrap {
    padding: 0 30px 10px;
    overflow: auto;
    .list_setindex_designer {
      display: flex;
      flex-flow: row;
      .item_setindex_designer {
        display: flex;
        align-items: center;
        background-color: #f4f4f4;
        padding: 5px;
        margin-right: 20px;
        border-radius: 100px;
        .avatar {
          width: 60px;
          height: 60px;
          flex-shrink: 0;
          box-shadow: inset 0 0 10px rgba(0, 0, 0, .05);
        }
        .name_wrap {
          flex: 1;
          padding: 0 10px;
          white-space: nowrap;
          .name {
            font-size: 14px;
            font-weight: bold;
          }
          .subname {
            opacity: .8;
          }
        }
      }
      .doufu {
        width: 10px;
        flex-shrink: 0;
      }
    }
  }
}


/** 图纸 套组详情页 **/
#setindex_instruction {
  padding: 10px 0 10px;
  .main_title {
    padding-left: 30px;
    padding-right: 30px;
  }
  .list_setindex_instruction_wrap {
    padding: 0 30px 10px;
    overflow: auto;
    position: relative;
    .list_setindex_instruction {
      .item_setindex_instruction {
        display: flex;
        margin: 20px 0;
        align-items: start;
        .icon {
          flex-shrink: 0;
          margin-right: 5px;
          font-size: 42px;
        }
        .cover {
          flex-shrink: 0;
          margin-right: 10px;
          /*background-image: url(../img/img_blank.png);*/
          background-position: center;
          background-repeat: no-repeat;
          background-size: cover;
          width: 80px;
          height: 60px;
          border-radius: 5px;
        }
        .title_wrap {
          flex: 1;
          .title {
            font-size: 14px;
            font-weight: bold;
            color: #333;
            padding-top: 3px;
          }
          .text {
            opacity: .5;
          }
        }
        .btn {
          color: #e62828;
          background-color: #fff4f4;
          display: inline-block;
          line-height: 30px;
          padding: 0 10px;
          height: 30px;
          margin-top: 5px;
          vertical-align: top;
        }
      }
    }
    .card_more {
      color: #e62828;
      background-color: transparent;
    }
    &.folded {
      .list_setindex_instruction {
        height: 250px;
        overflow: hidden;
      }
    }
  }

}


/** 视频 套组详情页 **/
#setindex_video {
  padding: 10px 0 10px;
  .main_title {
    padding-left: 30px;
    padding-right: 30px;
  }
  .list_setindex_video_wrap {
    padding: 0 30px 10px;
    overflow: auto;
    .list_setindex_video {
      display: flex;
      flex-flow: row;
      .item_setindex_video {
        width: 60%;
        margin-right: 20px;
        flex: 0 0 60%;
        @media only screen and (min-width: 370px) {
          width: 40%;
          flex: 0 0 40%;
        }
        @media only screen and (min-width: 500px) {
          width: 30%;
          flex: 0 0 30%;
        }
        @media only screen and (min-width: 550px) {
          width: 25%;
          flex: 0 0 25%;
        }
        .cover {
          padding-top: 57%;
          background-size: cover;
          background-repeat: no-repeat;
          background-position: center;
          margin-bottom: 10px;
          border-radius: 10px;
          position: relative;
          box-shadow: inset 0 0 20px rgba(0,0,0,.05);
          &.nocover {
            background-color: #f4f4f4;
            overflow: hidden;
            &:before {
              content: "";
              display: block;
              width: 100%;
              height: 38px;
              background-image: linear-gradient(180deg,rgba(0,0,0,0) 0%,rgba(0,0,0,.2) 100%);
              position: absolute;
              left: 0;
              bottom: 0;
            }
            .textbg {
              position: absolute;
              top: 0;
              left: 0;
              width: 400px;
              font-size: 60px;
              font-weight: bold;
              opacity: .05;
              color: #000;
            }
            .material-icons {
              font-size: 48px;
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              color: #ef3a3a;
              text-shadow: 0 0 20px rgba(230, 40, 40, .3);;
            }
            .video_duration {
              position: absolute;
              right: 5px;
              bottom: 5px;
              color: #fff;
              text-shadow: 0 0 5px rgba(0,0,0,.2), 0 0 1px rgba(0,0,0,.4);
            }
          }
        }
        .title {
          font-size: 14px;
          font-weight: bold;
          color: #333;
        }
      }
      .doufu {
        width: 10px;
        flex-shrink: 0;
      }
    }
  }
}





/** 文章 套组详情页 **/
#setindex_article {
  padding: 10px 30px 20px;
  .main_tips {
    margin-left: 0;
    margin-right: 0;
  }
}

.list_setindex_article_wrap {
  position: relative;
  .list_setindex_article {
    .item_setindex_article {
      display: block;
      margin-bottom: 20px;
      .cover_wrap {
        overflow: hidden;
        margin-bottom: 10px;
        border-radius: 10px;
        .cover {
          padding-top: 40%;
          background-size: cover;
          background-repeat: no-repeat;
          background-position: center;
          transition: all .3s;
        }
      }
      .item_setindex_article_box {
        display: flex;
        .favicon {
          vertical-align: middle;
          display: inline-block;
          width: 16px;
          height: 16px;
          background-image: url(~@img/urlicon.png);
          background-repeat: no-repeat;
          background-size: cover;
          margin-right: 5px;
          flex-shrink: 0;
        }
        .title_wrap {
          flex: 1;
          overflow: hidden;
          .title {
            padding: 5px 0;
            font-size: 14px;
            font-weight: bold;
            color: #333;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            * {
              vertical-align: middle;
            }
          }
          .author_wrap {
            display: flex;
            align-items: center;
            .avatar {
              flex-shrink: 0;
              margin-right: 5px;
              box-shadow: inset 0 0 10px rgba(0, 0, 0, .05);
              background-color: #eee;
              background-image: none;
              width: 10px;
              height: 10px;
            }
            .author {
              flex: 1;
            }
            .from {
              opacity: .5;
            }
          }
        }
      }
      &:not(:last-child) {
        padding-bottom: 20px;
        border-bottom: solid 1px #f4f4f4;
      }
      &:hover {
        .cover {
          transform: scale(1.05);
        }
        .title {
          background-color: #f4f4f4;
        }
      }
    }
  }
  .card_more {
    color: #e62828;
    background-color: transparent;
  }
  &.folded {
    .list_setindex_article {
      height: 400px;
      overflow: hidden;
    }
  }
}











.item_setindex_article2 {
  display: block;
  margin-bottom: 20px;
  .cover {
    padding-top: 40%;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    margin-bottom: 10px;
    border-radius: 10px;
  }
  .item_setindex_article_box {
    /*display: flex;*/
    .title_wrap_wrap{
      position: relative;
      padding-left: 15px;
      .title_wrap {
        margin-bottom: 10px;
        .title {
          font-size: 14px;
          font-weight: bold;
          color: #333;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          /*padding: 0 0 5px 15px;*/
          padding: 5px 0;
          position: relative;
          display: block;
          * {
            vertical-align: middle;
          }
          /*
          &:before {
            content: "";
            display: block;
            width: 4px;
            height: 4px;
            background-color: #333;
            position: absolute;
            left: 0;
            top: 50%;
            margin-top: -2px;
          }
          */
          &:hover {
            background-color: #f4f4f4;
          }
        }
        .from {
          opacity: .5;
          text-align: right;
        }
      }
      &:before {
        content: "";
        display: block;
        width: 4px;
        background-color: #e8e8e8;
        position: absolute;
        left: 2px;
        top: 5px;
        bottom: 20px;
      }
    }
    .author_wrap {
      display: flex;
      align-items: center;
      .avatar {
        flex-shrink: 0;
        margin-right: 5px;
        box-shadow: inset 0 0 10px rgba(0, 0, 0, .05);
        background-color: #eee;
        background-image: none;
        width: 10px;
        height: 10px;
      }
      .author {
        /*flex: 1;*/
      }
      .more {
        opacity: .5;
      }
    }
  }
  &:not(:last-child) {
    padding-bottom: 20px;
    border-bottom: solid 1px #f4f4f4;
  }
}







/** 购买 套组详情页 **/
#setindex_shopping {
  padding: 10px 30px 20px;
  .main_tips {
    margin-left: 0;
    margin-right: 0;
  }
}

.list_setindex_shopping {
  .item_setindex_shopping {
    margin-bottom: 10px;
    display: flex;
    flex-flow: row;
    align-items: center;
    cursor: pointer;
    .logo {
      width: 20px;
      height: 20px;
      flex-shrink: 0;
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center;
      /*box-shadow: inset 0 0 5px rgba(0,0,0,.1);*/
      border-radius: 3px;
    }
    .title_wrap {
      flex: 1;
      padding: 0 10px;
      overflow: hidden;
      .title {
        /*font-size: 14px;*/
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        color: #333;
      }
      .time {
        opacity: 80%;
      }
    }
    .price {
      color: #e62828;
      font-weight: bold;
    }
    .btn_buy {
      line-height: 35px;
      padding: 0 15px;
      border-radius: 100px;
      margin-left: 10px;
      * {
        display: inline-block;
        line-height: inherit;
        vertical-align: top;
      }
      .material-icons {
        font-size: 18px;
        padding-right: 5px;
      }
    }
    &:nth-child(2n) {
      background-color: #fdfdfd;
    }
  }
}



/** 关联套组 套组详情页 **/
#setindex_relset {
  padding: 10px 30px 20px;
  position: relative;
}

.list_setindex_relset_wrap {
  .card_more {
    margin-bottom: 20px;
    color: #e62828;
    background-color: transparent;
  }
  &.folded {
    .list_setindex_relset {
      height: 300px;
      overflow: hidden;
    }
  }
}


.item_setindex_relset {
  margin-bottom: 5px;
  display: flex;
  flex-flow: row;
  overflow: hidden;
  align-items: center;
  padding: 5px 10px 5px 5px;
  border-radius: 5px;
  position: relative;
  background-image: linear-gradient(to left, #f4f4f4 20%, rgba(255,255,255,0) 60%);
  box-shadow: inset 0 0 10px #f6f6f6;
  &.active {
    box-shadow: inset 0 0 0 1px #e62828;
    background-image: none;
    &:after {
      content: "当前款";
      display: block;
      background-color: #e62828;
      color: #fff;
      padding: 0 5px;
      line-height: 20px;
      /*margin-top: 20px;
      transform: scale(.8);
      transform-origin: 0 50%;*/
      white-space: nowrap;
      position: absolute;
      bottom: 0;
      right: 0;
    }
  }
  .cover {
    width: 60px;
    height: 60px;
    flex-shrink: 0;
    margin-right: 10px;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
  }
  .title_wrap {
    flex: 1;
    overflow: hidden;
    .brandandnumber {
      align-items: center;
      display: flex;
      /*padding: 10px 0 0;*/
      color: #333;
      white-space: nowrap;
      line-height: 1;
      .logo {
        display: inline-block;
        width: 16px;
        height: 16px;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;
        flex-shrink: 0;
        margin-right: 5px;
        border-radius: 4px;
        /*box-shadow: inset 0 0 5px rgba(0,0,0,.1);*/
      }
      .brand {
        /*flex: 1;*/
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        padding-right: 5px;
      }
      .number {
        flex-shrink: 0;
        white-space: nowrap;
        font-weight: bold;
      }
    }
    .title {
      white-space: nowrap;
      font-weight: bold;
      color: #333;
    }
    .remarks {
      opacity: .8;
    }
  }
}


/** 推荐套组 套组详情页 **/
#setindex_recommendset {
  padding: 10px 30px 20px;
  .list_moresearch {
    .btn {
      display: inline-block;
      color: #e62828;
      background-color: #fff4f4;
      display: inline-block;
      line-height: 30px;
      padding: 0 10px;
      height: 30px;
      margin: 0 5px 5px 0;
    }
  }
  .brandcard {
    display: flex;
    align-items: center;
    margin: 20px 0;
    .logo {
      display: inline-block;
      width: 60px;
      height: 60px;
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center;
      flex-shrink: 0;
      margin-right: 10px;
      border-radius: 4px;
    }
    .title_wrap {
      flex: 1;
      white-space: nowrap;
    }
    .title {
      /* flex: 1; */
      white-space: nowrap;
      text-overflow: ellipsis;
      padding-right: 5px;
      overflow: hidden;
      display: block;
      font-size: 14px;
      font-weight: bold;
      margin-bottom: 5px;
    }
    .btn {
      display: inline-block;
      color: #e62828;
      background-color: #fff4f4;
      display: inline-block;
      line-height: 30px;
      padding: 0 10px;
      height: 30px;
      margin: 0 5px 5px 0;
      vertical-align: top;
    }
  }
}

.list_setindex_recommendset {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -5px;
  .item_setindex_recommendset {
    /*flex: 0 0 50%;*/
    width: 50%;
    padding: 5px;
    position: relative;
    .item_setindex_recommendset_box {
      box-shadow: 0 0 10px rgba(0,0,0,.1);
      border-radius: 10px;
      transition: all .3s;
      overflow: hidden;
      height: 100%;

      .sign {
        /*display: inline-block;*/
        position: absolute;
        top: 5px;
        right: 5px;
        font-weight: initial;
        background-color: #ffcf00;
        color: #333;
        line-height: 24px;
        padding: 0 5px;
        /*transform: scale(.8);
        transform-origin: 100% 0;*/
        border-radius: 3px;
        &.sign_newrelease {
          background-color: #fff;
          color: #ef3a3a;
          box-shadow: inset 0 0 0 1px #ef3a3a;
        }
        &.sign_newadd {
          background-color: #fff;
          color: #42bf53;
          box-shadow: inset 0 0 0 1px #42bf53;
        }
        &.sign_outofprint {
          background-color: #f4f4f4;
          color: #999;
          box-shadow: inset 0 0 0 1px #999;
        }
        &.sign_outofprintsoon {
          background-color: #333;
          color: #ffcf00;
        }
      }

      .cover_wrap {
        width: 100%;
        padding-top: 100%;
        position: relative;
        .cover {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          margin-right: 10px;
          background-size: contain;
          background-repeat: no-repeat;
          background-position: center;
          transition: all .3s;
        }
        &:after {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          /*background-color: rgba(0,0,0,.04);*/
          background-image: linear-gradient(rgba(0, 0, 0, 0) 90%, rgba(0, 0, 0, 0.04));
          opacity: 1;
          transition: all .3s;
        }
      }
      .title_wrap {
        padding: 20px 20px 30px;
        .title {
          font-size: 15px;
          font-weight: bold;
          overflow : hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          color: #333;
        }
        .subtitle {
          overflow : hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          color: #666;
        }
        .brandandnumber {
          align-items: center;
          display: flex;
          padding: 10px 0 0;
          color: #333;
          white-space: nowrap;
          line-height: 1;
          .logo {
            display: inline-block;
            width: 20px;
            height: 20px;
            background-size: cover;
            background-repeat: no-repeat;
            background-position: center;
            flex-shrink: 0;
            margin-right: 5px;
            border-radius: 4px;
            /*box-shadow: inset 0 0 5px rgba(0,0,0,.1);*/
          }
          .brand {
            /*flex: 1;*/
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            padding-right: 5px;
          }
          .number {
            flex-shrink: 0;
            white-space: nowrap;
            font-weight: bold;
          }
        }
      }
      &:hover {
        box-shadow: 0 0 20px rgba(0,0,0,.2);
        z-index: 1;
        .cover_wrap {
          .cover {
            transform: scale(.95);
          }
          &:after {
            opacity: 0;
          }
        }
      }
    }
  }
}




/** 页脚免责 套组详情页 **/
#setindex_footer {
  padding: 20px 30px 60px;
  color: #999;

  a {
    cursor: pointer;
    color: #e62828;
  }

}



/** 底栏 套组详情页 **/
#setindex_bottombar {
  z-index: 13;
  transform: translateY(100px);
  transition: all 0.3s;
  &.hasshow {
    transform: translateY(0);
  }
  .bottombar_box {
    height: 60px;
    .price {
      color: #e62828;
      font-size: 20px;
      /*text-align: right;*/
      font-weight: bold;
      &.disabled {
        font-size: 12px;
        color: #d6d6d6;
      }
      .ppp {
        font-size: 12px;
        color: #999;
        font-weight: normal;
        transform: scale(.9);
      }
    }
    .btn {
      /*line-height: 50px;
      height: 50px;*/
    }
  }
}



/** 相册面板 **/
.subplate_album {
  top: 80px;
  .subplate_box {
    padding: 30px 30px 70px;
    .pic_list {
      img {
        width: 100%;
      }
    }
  }
}


/** 视频面板 **/
.subplate_video {
  top: 0;
  .subplate_box {
    /*padding: 30px 30px 70px;*/
    position: relative;
    height: 100%;
    div {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 50px;
      iframe {
        width: 640px;
        height: 100%;
        max-width: 100%;
      }
    }
  }
}


</style>



// WEBPACK FOOTER //
// src/views/set/SetIndex.vue